/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest } from "../myModel";
// @ts-ignore
import type { Attachment } from "../myModel";
// @ts-ignore
import type { Category } from "../myModel";
// @ts-ignore
import type { Challenge } from "../myModel";
// @ts-ignore
import type { ChallengeWithKey } from "../myModel";
// @ts-ignore
import type { ChangePassword } from "../myModel";
// @ts-ignore
import type { CheckIn } from "../myModel";
// @ts-ignore
import type { CheckOutDatetime } from "../myModel";
// @ts-ignore
import type { Client } from "../myModel";
// @ts-ignore
import type { Credentials } from "../myModel";
// @ts-ignore
import type { CurrentUser } from "../myModel";
// @ts-ignore
import type { CustomError } from "../myModel";
// @ts-ignore
import type { DashboardSummary } from "../myModel";
// @ts-ignore
import type { Email } from "../myModel";
// @ts-ignore
import type { EmailOTPChallenge } from "../myModel";
// @ts-ignore
import type { FileRelations } from "../myModel";
// @ts-ignore
import type { Location } from "../myModel";
// @ts-ignore
import type { ManualTimeLog } from "../myModel";
// @ts-ignore
import type { Materials } from "../myModel";
// @ts-ignore
import type { OtpKey } from "../myModel";
// @ts-ignore
import type { PaginatedClientList } from "../myModel";
// @ts-ignore
import type { PaginatedFileList } from "../myModel";
// @ts-ignore
import type { PaginatedFileRelationsList } from "../myModel";
// @ts-ignore
import type { PaginatedLocationList } from "../myModel";
// @ts-ignore
import type { PaginatedMaterialsList } from "../myModel";
// @ts-ignore
import type { PaginatedNotificationList } from "../myModel";
// @ts-ignore
import type { PaginatedNotificationListList } from "../myModel";
// @ts-ignore
import type { PaginatedProjectList } from "../myModel";
// @ts-ignore
import type { PaginatedServicesList } from "../myModel";
// @ts-ignore
import type { PaginatedTicketCommentDetailedList } from "../myModel";
// @ts-ignore
import type { PaginatedTicketMaterialsUsageList } from "../myModel";
// @ts-ignore
import type { PaginatedTicketStandbyPeriodList } from "../myModel";
// @ts-ignore
import type { PaginatedTimeTrackingList } from "../myModel";
// @ts-ignore
import type { PaginatedUserList } from "../myModel";
// @ts-ignore
import type { PaginatedUserProfileList } from "../myModel";
// @ts-ignore
import type { PaginatedWorkHistoryDetailedList } from "../myModel";
// @ts-ignore
import type { PaginatedWorkLogList } from "../myModel";
// @ts-ignore
import type { PaginatedclientTurbinesResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedcomponentResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedtechnicianTicketResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedtechnicianTurbineResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedticketResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedturbineComponentResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedturbineResultsSideloadList } from "../myModel";
// @ts-ignore
import type { PaginatedturbineWoResultsSideloadList } from "../myModel";
// @ts-ignore
import type { Password } from "../myModel";
// @ts-ignore
import type { PatchedClient } from "../myModel";
// @ts-ignore
import type { PatchedFileRelations } from "../myModel";
// @ts-ignore
import type { PatchedLocation } from "../myModel";
// @ts-ignore
import type { PatchedMaterials } from "../myModel";
// @ts-ignore
import type { PatchedProject } from "../myModel";
// @ts-ignore
import type { PatchedRejectTicket } from "../myModel";
// @ts-ignore
import type { PatchedReportDelay } from "../myModel";
// @ts-ignore
import type { PatchedServices } from "../myModel";
// @ts-ignore
import type { PatchedTechnicianTurbine } from "../myModel";
// @ts-ignore
import type { PatchedTicket } from "../myModel";
// @ts-ignore
import type { PatchedTicketComment } from "../myModel";
// @ts-ignore
import type { PatchedTicketIndexRequest } from "../myModel";
// @ts-ignore
import type { PatchedTicketMaterialsUsage } from "../myModel";
// @ts-ignore
import type { PatchedTicketStandbyPeriod } from "../myModel";
// @ts-ignore
import type { PatchedTimeEntryEdit } from "../myModel";
// @ts-ignore
import type { PatchedTurbine } from "../myModel";
// @ts-ignore
import type { PatchedTurbineComponent } from "../myModel";
// @ts-ignore
import type { PatchedUserCreateUpdate } from "../myModel";
// @ts-ignore
import type { PatchedUserProfile } from "../myModel";
// @ts-ignore
import type { PatchedWorkHistory } from "../myModel";
// @ts-ignore
import type { Project } from "../myModel";
// @ts-ignore
import type { ProjectDetailed } from "../myModel";
// @ts-ignore
import type { ProjectStatus } from "../myModel";
// @ts-ignore
import type { Services } from "../myModel";
// @ts-ignore
import type { Status } from "../myModel";
// @ts-ignore
import type { TOTPToken } from "../myModel";
// @ts-ignore
import type { TechnicianTurbine } from "../myModel";
// @ts-ignore
import type { Ticket } from "../myModel";
// @ts-ignore
import type { TicketComment } from "../myModel";
// @ts-ignore
import type { TicketCommentReaction } from "../myModel";
// @ts-ignore
import type { TicketData } from "../myModel";
// @ts-ignore
import type { TicketMaterialsUsage } from "../myModel";
// @ts-ignore
import type { TicketRetrieve } from "../myModel";
// @ts-ignore
import type { TicketStandbyPeriod } from "../myModel";
// @ts-ignore
import type { TicketStandbyPeriodEdit } from "../myModel";
// @ts-ignore
import type { TimeTracking } from "../myModel";
// @ts-ignore
import type { TokenObtainPair } from "../myModel";
// @ts-ignore
import type { TokenRefresh } from "../myModel";
// @ts-ignore
import type { Turbine } from "../myModel";
// @ts-ignore
import type { TurbineComponent } from "../myModel";
// @ts-ignore
import type { TurbineComponentRetrieve } from "../myModel";
// @ts-ignore
import type { TurbineRetrieve } from "../myModel";
// @ts-ignore
import type { User } from "../myModel";
// @ts-ignore
import type { UserCreateUpdate } from "../myModel";
// @ts-ignore
import type { UserGroup } from "../myModel";
// @ts-ignore
import type { UserProfile } from "../myModel";
// @ts-ignore
import type { WorkHistory } from "../myModel";
/**
 * ApiApi - axios parameter creator
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthCheckCredentialsCreate: async (
      credentials: Credentials,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'credentials' is not null or undefined
      assertParamExists(
        "apiV1ManagementAuthCheckCredentialsCreate",
        "credentials",
        credentials
      );
      const localVarPath = `/api/v1/management/auth/check_credentials/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        credentials,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EmailOTPChallenge} emailOTPChallenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthEmailOtpLoginCreate: async (
      emailOTPChallenge: EmailOTPChallenge,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'emailOTPChallenge' is not null or undefined
      assertParamExists(
        "apiV1ManagementAuthEmailOtpLoginCreate",
        "emailOTPChallenge",
        emailOTPChallenge
      );
      const localVarPath = `/api/v1/management/auth/email_otp_login/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        emailOTPChallenge,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ChallengeWithKey} challengeWithKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthLoginCreate: async (
      challengeWithKey: ChallengeWithKey,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'challengeWithKey' is not null or undefined
      assertParamExists(
        "apiV1ManagementAuthLoginCreate",
        "challengeWithKey",
        challengeWithKey
      );
      const localVarPath = `/api/v1/management/auth/login/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        challengeWithKey,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefresh} tokenRefresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthRefreshCreate: async (
      tokenRefresh: TokenRefresh,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tokenRefresh' is not null or undefined
      assertParamExists("apiV1ManagementAuthRefreshCreate", "tokenRefresh", tokenRefresh);
      const localVarPath = `/api/v1/management/auth/refresh/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tokenRefresh,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Email} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthResetPasswordCreate: async (
      email: Email,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists("apiV1ManagementAuthResetPasswordCreate", "email", email);
      const localVarPath = `/api/v1/management/auth/reset_password/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        email,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsCreate: async (
      client: Client,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'client' is not null or undefined
      assertParamExists("apiV1ManagementClientsCreate", "client", client);
      const localVarPath = `/api/v1/management/clients/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementClientsDestroy", "id", id);
      const localVarPath = `/api/v1/management/clients/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsList: async (
      currentPage?: number,
      legalName?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/clients/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (legalName !== undefined) {
        localVarQueryParameter["legal_name"] = legalName;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (taxId !== undefined) {
        localVarQueryParameter["tax_id"] = taxId;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {PatchedClient} [patchedClient]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsPartialUpdate: async (
      id: string,
      patchedClient?: PatchedClient,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementClientsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/clients/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedClient,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementClientsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/clients/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementClientsTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsTurbinesList: async (
      clientId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementClientsTurbinesListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists("apiV1ManagementClientsTurbinesList", "clientId", clientId);
      const localVarPath = `/api/v1/management/clients/{client_id}/turbines/`.replace(
        `{${"client_id"}}`,
        encodeURIComponent(String(clientId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsUpdate: async (
      id: string,
      client: Client,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementClientsUpdate", "id", id);
      // verify required parameter 'client' is not null or undefined
      assertParamExists("apiV1ManagementClientsUpdate", "client", client);
      const localVarPath = `/api/v1/management/clients/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        client,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementComponentsDestroy", "id", id);
      const localVarPath = `/api/v1/management/components/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiV1ManagementComponentsListComponentTypeEnum} [componentType] * &#x60;BLADE&#x60; - Blade * &#x60;NACELLE&#x60; - Nacelle * &#x60;HUB&#x60; - Hub * &#x60;TOWER&#x60; - Tower
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [manufacturer]
     * @param {string} [model]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {string} [setNumber]
     * @param {Array<ApiV1ManagementComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsList: async (
      componentType?: ApiV1ManagementComponentsListComponentTypeEnum,
      currentPage?: number,
      manufacturer?: string,
      model?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      setNumber?: string,
      sideload?: Array<ApiV1ManagementComponentsListSideloadEnum>,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/components/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (componentType !== undefined) {
        localVarQueryParameter["component_type"] = componentType;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (manufacturer !== undefined) {
        localVarQueryParameter["manufacturer"] = manufacturer;
      }

      if (model !== undefined) {
        localVarQueryParameter["model"] = model;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (serialNumber !== undefined) {
        localVarQueryParameter["serial_number"] = serialNumber;
      }

      if (setNumber !== undefined) {
        localVarQueryParameter["set_number"] = setNumber;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {PatchedTurbineComponent} [patchedTurbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsPartialUpdate: async (
      id: string,
      patchedTurbineComponent?: PatchedTurbineComponent,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementComponentsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/components/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTurbineComponent,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {Array<ApiV1ManagementComponentsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementComponentsRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementComponentsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/components/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {TurbineComponent} [turbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsUpdate: async (
      id: string,
      turbineComponent?: TurbineComponent,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementComponentsUpdate", "id", id);
      const localVarPath = `/api/v1/management/components/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        turbineComponent,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementDashboardRetrieve: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/dashboard/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [file]
     * @param {string} [location]
     * @param {string} [material]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [ticketItem]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementEntityWorklogList: async (
      client?: string,
      component?: string,
      currentPage?: number,
      file?: string,
      location?: string,
      material?: string,
      perPage?: number,
      project?: string,
      ticketItem?: string,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/entity_worklog/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (component !== undefined) {
        localVarQueryParameter["component"] = component;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (file !== undefined) {
        localVarQueryParameter["file"] = file;
      }

      if (location !== undefined) {
        localVarQueryParameter["location"] = location;
      }

      if (material !== undefined) {
        localVarQueryParameter["material"] = material;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (project !== undefined) {
        localVarQueryParameter["project"] = project;
      }

      if (ticketItem !== undefined) {
        localVarQueryParameter["ticket_item"] = ticketItem;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFileRelationsDestroy", "id", id);
      const localVarPath = `/api/v1/management/file_relations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsList: async (
      currentPage?: number,
      perPage?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/file_relations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {PatchedFileRelations} [patchedFileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsPartialUpdate: async (
      id: string,
      patchedFileRelations?: PatchedFileRelations,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFileRelationsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/file_relations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedFileRelations,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFileRelationsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/file_relations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {FileRelations} [fileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsUpdate: async (
      id: string,
      fileRelations?: FileRelations,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFileRelationsUpdate", "id", id);
      const localVarPath = `/api/v1/management/file_relations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        fileRelations,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} file
     * @param {Attachment} metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesCreate: async (
      file: string,
      metadata: Attachment,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists("apiV1ManagementFilesCreate", "file", file);
      // verify required parameter 'metadata' is not null or undefined
      assertParamExists("apiV1ManagementFilesCreate", "metadata", metadata);
      const localVarPath = `/api/v1/management/files/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      if (metadata !== undefined) {
        localVarFormParams.append(
          "metadata",
          new Blob([JSON.stringify(metadata, replaceWithSerializableTypeIfNeeded)], {
            type: "application/json",
          })
        );
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this file model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFilesDestroy", "id", id);
      const localVarPath = `/api/v1/management/files/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesDownloadRetrieve: async (
      id: string,
      token?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFilesDownloadRetrieve", "id", id);
      const localVarPath = `/api/v1/management/files/{id}/download/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (token !== undefined) {
        localVarQueryParameter["token"] = token;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {ApiV1ManagementFilesListFileRelationsPurposeEnum} [fileRelationsPurpose] * &#x60;PLACEHOLDER1&#x60; - Placeholder 1 * &#x60;PLACEHOLDER2&#x60; - Placeholder 2 * &#x60;PLACEHOLDER3&#x60; - Placeholder 3
     * @param {string} [fileRelationsTicket]
     * @param {number} [fileRelationsUploadedBy]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesList: async (
      currentPage?: number,
      fileRelationsPurpose?: ApiV1ManagementFilesListFileRelationsPurposeEnum,
      fileRelationsTicket?: string,
      fileRelationsUploadedBy?: number,
      ordering?: string,
      perPage?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/files/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (fileRelationsPurpose !== undefined) {
        localVarQueryParameter["file_relations__purpose"] = fileRelationsPurpose;
      }

      if (fileRelationsTicket !== undefined) {
        localVarQueryParameter["file_relations__ticket"] = fileRelationsTicket;
      }

      if (fileRelationsUploadedBy !== undefined) {
        localVarQueryParameter["file_relations__uploaded_by"] = fileRelationsUploadedBy;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesThumbnailRetrieve: async (
      id: string,
      token?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementFilesThumbnailRetrieve", "id", id);
      const localVarPath = `/api/v1/management/files/{id}/thumbnail/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (token !== undefined) {
        localVarQueryParameter["token"] = token;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [material]
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementGlobalNotificationsList: async (
      client?: string,
      component?: string,
      currentPage?: number,
      location?: string,
      material?: string,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      project?: string,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/global_notifications/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (component !== undefined) {
        localVarQueryParameter["component"] = component;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (location !== undefined) {
        localVarQueryParameter["location"] = location;
      }

      if (material !== undefined) {
        localVarQueryParameter["material"] = material;
      }

      if (notificationType !== undefined) {
        localVarQueryParameter["notification_type"] = notificationType;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (project !== undefined) {
        localVarQueryParameter["project"] = project;
      }

      if (recipient !== undefined) {
        localVarQueryParameter["recipient"] = recipient;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sender !== undefined) {
        localVarQueryParameter["sender"] = sender;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/global_notifications/{id}/mark_as_read/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsCreate: async (
      location: Location,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'location' is not null or undefined
      assertParamExists("apiV1ManagementLocationsCreate", "location", location);
      const localVarPath = `/api/v1/management/locations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        location,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementLocationsDestroy", "id", id);
      const localVarPath = `/api/v1/management/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsList: async (
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      search?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/locations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {PatchedLocation} [patchedLocation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsPartialUpdate: async (
      id: string,
      patchedLocation?: PatchedLocation,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementLocationsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedLocation,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementLocationsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsUpdate: async (
      id: string,
      location: Location,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementLocationsUpdate", "id", id);
      // verify required parameter 'location' is not null or undefined
      assertParamExists("apiV1ManagementLocationsUpdate", "location", location);
      const localVarPath = `/api/v1/management/locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        location,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TOTPToken} tOTPToken
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginConfirmMfaKeyCreate: async (
      tOTPToken: TOTPToken,
      secret?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tOTPToken' is not null or undefined
      assertParamExists(
        "apiV1ManagementLoginConfirmMfaKeyCreate",
        "tOTPToken",
        tOTPToken
      );
      const localVarPath = `/api/v1/management/login/confirm_mfa_key/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (secret !== undefined) {
        localVarQueryParameter["secret"] = secret;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        tOTPToken,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginGetMfaKeyRetrieve: async (
      secret?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/login/get_mfa_key/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (secret !== undefined) {
        localVarQueryParameter["secret"] = secret;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Password} password
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginSetPasswordCreate: async (
      password: Password,
      secret?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'password' is not null or undefined
      assertParamExists("apiV1ManagementLoginSetPasswordCreate", "password", password);
      const localVarPath = `/api/v1/management/login/set_password/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (secret !== undefined) {
        localVarQueryParameter["secret"] = secret;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        password,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsCreate: async (
      materials: Materials,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'materials' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsCreate", "materials", materials);
      const localVarPath = `/api/v1/management/materials/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        materials,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsDestroy", "id", id);
      const localVarPath = `/api/v1/management/materials/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiV1ManagementMaterialsListCategoryEnum} [category] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [sapCode]
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsList: async (
      category?: ApiV1ManagementMaterialsListCategoryEnum,
      currentPage?: number,
      name?: string,
      perPage?: number,
      sapCode?: string,
      search?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/materials/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (category !== undefined) {
        localVarQueryParameter["category"] = category;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (sapCode !== undefined) {
        localVarQueryParameter["sap_code"] = sapCode;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {PatchedMaterials} [patchedMaterials]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsPartialUpdate: async (
      id: string,
      patchedMaterials?: PatchedMaterials,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/materials/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedMaterials,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/materials/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsUpdate: async (
      id: string,
      materials: Materials,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsUpdate", "id", id);
      // verify required parameter 'materials' is not null or undefined
      assertParamExists("apiV1ManagementMaterialsUpdate", "materials", materials);
      const localVarPath = `/api/v1/management/materials/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        materials,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMeRetrieve: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaCategoriesList: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/meta/categories`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaGroupsList: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/meta/groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaProjectStatusesList: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/meta/project-statuses`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaTicketStatusesList: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/meta/ticket-statuses`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementNotificationsDestroy", "id", id);
      const localVarPath = `/api/v1/management/notifications/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsList: async (
      currentPage?: number,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/notifications/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (notificationType !== undefined) {
        localVarQueryParameter["notification_type"] = notificationType;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sender !== undefined) {
        localVarQueryParameter["sender"] = sender;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsMarkAllAsReadPartialUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementNotificationsMarkAllAsReadPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/notifications/{id}/mark_all_as_read/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsMarkAsReadPartialUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementNotificationsMarkAsReadPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/notifications/{id}/mark_as_read/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsCreate: async (
      project?: Project,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/projects/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        project,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementProjectsDestroy", "id", id);
      const localVarPath = `/api/v1/management/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsList: async (
      client?: string,
      currentPage?: number,
      name?: string,
      ordering?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementProjectsListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/projects/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (projectStatus !== undefined) {
        localVarQueryParameter["project_status"] = projectStatus;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {PatchedProject} [patchedProject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsPartialUpdate: async (
      id: string,
      patchedProject?: PatchedProject,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementProjectsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedProject,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementProjectsRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementProjectsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsUpdate: async (
      id: string,
      project?: Project,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementProjectsUpdate", "id", id);
      const localVarPath = `/api/v1/management/projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        project,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {ApiV1ManagementSchemaRetrieveFormatEnum} [format]
     * @param {ApiV1ManagementSchemaRetrieveLangEnum} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementSchemaRetrieve: async (
      format?: ApiV1ManagementSchemaRetrieveFormatEnum,
      lang?: ApiV1ManagementSchemaRetrieveLangEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/schema/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      if (lang !== undefined) {
        localVarQueryParameter["lang"] = lang;
      }

      localVarHeaderParameter["Accept"] =
        "application/vnd.oai.openapi,application/yaml,application/vnd.oai.openapi+json,application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesCreate: async (
      services: Services,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'services' is not null or undefined
      assertParamExists("apiV1ManagementServicesCreate", "services", services);
      const localVarPath = `/api/v1/management/services/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        services,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementServicesDestroy", "id", id);
      const localVarPath = `/api/v1/management/services/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesList: async (
      currentPage?: number,
      name?: string,
      perPage?: number,
      search?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/services/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {PatchedServices} [patchedServices]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesPartialUpdate: async (
      id: string,
      patchedServices?: PatchedServices,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementServicesPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/services/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedServices,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementServicesRetrieve", "id", id);
      const localVarPath = `/api/v1/management/services/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesUpdate: async (
      id: string,
      services: Services,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementServicesUpdate", "id", id);
      // verify required parameter 'services' is not null or undefined
      assertParamExists("apiV1ManagementServicesUpdate", "services", services);
      const localVarPath = `/api/v1/management/services/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        services,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechClientsList: async (
      currentPage?: number,
      legalName?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/tech_clients/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (legalName !== undefined) {
        localVarQueryParameter["legal_name"] = legalName;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (taxId !== undefined) {
        localVarQueryParameter["tax_id"] = taxId;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechLocationsList: async (
      currentPage?: number,
      perPage?: number,
      search?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/tech_locations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechLocationsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechLocationsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/tech_locations/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementTechProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementTechProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechProjectsList: async (
      client?: string,
      currentPage?: number,
      name?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementTechProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementTechProjectsListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/tech_projects/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (projectStatus !== undefined) {
        localVarQueryParameter["project_status"] = projectStatus;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechProjectsRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechProjectsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/tech_projects/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTechTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesList: async (
      client?: string,
      currentPage?: number,
      location?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTechTurbinesListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/tech_turbines/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (location !== undefined) {
        localVarQueryParameter["location"] = location;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (serialNumber !== undefined) {
        localVarQueryParameter["serial_number"] = serialNumber;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTechnicianTurbine} [patchedTechnicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesPartialUpdate: async (
      id: string,
      patchedTechnicianTurbine?: PatchedTechnicianTurbine,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechTurbinesPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/tech_turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTechnicianTurbine,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechTurbinesRetrieve", "id", id);
      const localVarPath = `/api/v1/management/tech_turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {TechnicianTurbine} [technicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesUpdate: async (
      id: string,
      technicianTurbine?: TechnicianTurbine,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechTurbinesUpdate", "id", id);
      const localVarPath = `/api/v1/management/tech_turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        technicianTurbine,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckIn} checkIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersCheckInCreate: async (
      id: string,
      checkIn: CheckIn,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersCheckInCreate", "id", id);
      // verify required parameter 'checkIn' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersCheckInCreate",
        "checkIn",
        checkIn
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/{id}/check_in/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkIn,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckOutDatetime} checkOutDatetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersCheckOutCreate: async (
      id: string,
      checkOutDatetime: CheckOutDatetime,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersCheckOutCreate", "id", id);
      // verify required parameter 'checkOutDatetime' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersCheckOutCreate",
        "checkOutDatetime",
        checkOutDatetime
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/{id}/check_out/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkOutDatetime,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest} [apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersEndPartialUpdate: async (
      id: string,
      apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest?: ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersEndPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/technician/work-orders/{id}/end/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTechnicianWorkOrdersListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersList: async (
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>,
      status?: ApiV1ManagementTechnicianWorkOrdersListStatusEnum,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/technician/work-orders/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (assigneesAssignee !== undefined) {
        localVarQueryParameter["assignees__assignee"] = assigneesAssignee;
      }

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (coordinatorsCoordinator !== undefined) {
        localVarQueryParameter["coordinators__coordinator"] = coordinatorsCoordinator;
      }

      if (createdBy !== undefined) {
        localVarQueryParameter["created_by"] = createdBy;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (itemsComponentSerialNumber !== undefined) {
        localVarQueryParameter["items__component__serial_number"] =
          itemsComponentSerialNumber;
      }

      if (managersManager !== undefined) {
        localVarQueryParameter["managers__manager"] = managersManager;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (project !== undefined) {
        localVarQueryParameter["project"] = project;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (service !== undefined) {
        localVarQueryParameter["service"] = service;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [batch]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [material]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum} [materialCategory] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {string} [materialName]
     * @param {string} [materialSapCode]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum} [measurementUnit] * &#x60;KG&#x60; - kg * &#x60;G&#x60; - g * &#x60;L&#x60; - L * &#x60;ML&#x60; - ml * &#x60;M2&#x60; - m² * &#x60;EACH&#x60; - each
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsList: async (
      batch?: string,
      currentPage?: number,
      material?: string,
      materialCategory?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum,
      materialName?: string,
      materialSapCode?: string,
      measurementUnit?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum,
      ordering?: string,
      perPage?: number,
      search?: string,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/technician/work-orders/materials/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (batch !== undefined) {
        localVarQueryParameter["batch"] = batch;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (material !== undefined) {
        localVarQueryParameter["material"] = material;
      }

      if (materialCategory !== undefined) {
        localVarQueryParameter["material__category"] = materialCategory;
      }

      if (materialName !== undefined) {
        localVarQueryParameter["material__name"] = materialName;
      }

      if (materialSapCode !== undefined) {
        localVarQueryParameter["material__sap_code"] = materialSapCode;
      }

      if (measurementUnit !== undefined) {
        localVarQueryParameter["measurement_unit"] = measurementUnit;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {PatchedTicketMaterialsUsage} [patchedTicketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate: async (
      id: string,
      patchedTicketMaterialsUsage?: PatchedTicketMaterialsUsage,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/materials/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicketMaterialsUsage,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve", "id", id);
      const localVarPath =
        `/api/v1/management/technician/work-orders/materials/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {TicketMaterialsUsage} [ticketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsUpdate: async (
      id: string,
      ticketMaterialsUsage?: TicketMaterialsUsage,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersMaterialsUpdate", "id", id);
      const localVarPath =
        `/api/v1/management/technician/work-orders/materials/{id}/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticketMaterialsUsage,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersPartialUpdate: async (
      id: string,
      patchedTicket?: PatchedTicket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/technician/work-orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedReportDelay} [patchedReportDelay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate: async (
      id: string,
      patchedReportDelay?: PatchedReportDelay,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/{id}/report_delay/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedReportDelay,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersRetrieve", "id", id);
      const localVarPath = `/api/v1/management/technician/work-orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersStartPartialUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersStartPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/{id}/start/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ManualTimeLog} manualTimeLog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate: async (
      id: string,
      manualTimeLog: ManualTimeLog,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate",
        "id",
        id
      );
      // verify required parameter 'manualTimeLog' is not null or undefined
      assertParamExists(
        "apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate",
        "manualTimeLog",
        manualTimeLog
      );
      const localVarPath =
        `/api/v1/management/technician/work-orders/{id}/ticket_item_manual_time_log/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        manualTimeLog,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersUpdate: async (
      id: string,
      ticket: Ticket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersUpdate", "id", id);
      // verify required parameter 'ticket' is not null or undefined
      assertParamExists("apiV1ManagementTechnicianWorkOrdersUpdate", "ticket", ticket);
      const localVarPath = `/api/v1/management/technician/work-orders/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicketIndexRequest} [patchedTicketIndexRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketAssignIndexPartialUpdate: async (
      id: string,
      patchedTicketIndexRequest?: PatchedTicketIndexRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketAssignIndexPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/assign_index/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicketIndexRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TicketCommentReaction} ticketCommentReaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentReactionsCreate: async (
      ticketCommentReaction: TicketCommentReaction,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketCommentReaction' is not null or undefined
      assertParamExists(
        "apiV1ManagementTicketCommentReactionsCreate",
        "ticketCommentReaction",
        ticketCommentReaction
      );
      const localVarPath = `/api/v1/management/ticket_comment_reactions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticketCommentReaction,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment reaction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentReactionsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketCommentReactionsDestroy", "id", id);
      const localVarPath = `/api/v1/management/ticket_comment_reactions/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsCreate: async (
      ticketComment?: TicketComment,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket_comments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticketComment,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketCommentsDestroy", "id", id);
      const localVarPath = `/api/v1/management/ticket_comments/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [replyTo]
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {number} [user]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsList: async (
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      replyTo?: number,
      ticket?: string,
      ticketItem?: string,
      user?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket_comments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (replyTo !== undefined) {
        localVarQueryParameter["reply_to"] = replyTo;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      if (ticketItem !== undefined) {
        localVarQueryParameter["ticket_item"] = ticketItem;
      }

      if (user !== undefined) {
        localVarQueryParameter["user"] = user;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {PatchedTicketComment} [patchedTicketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsPartialUpdate: async (
      id: string,
      patchedTicketComment?: PatchedTicketComment,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketCommentsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket_comments/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicketComment,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsUpdate: async (
      id: string,
      ticketComment?: TicketComment,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketCommentsUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket_comments/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticketComment,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCreate: async (
      ticket: Ticket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticket' is not null or undefined
      assertParamExists("apiV1ManagementTicketCreate", "ticket", ticket);
      const localVarPath = `/api/v1/management/ticket/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketDelaysList: async (
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket_delays/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (recipient !== undefined) {
        localVarQueryParameter["recipient"] = recipient;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sender !== undefined) {
        localVarQueryParameter["sender"] = sender;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketDestroy", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {boolean} [reportDone]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTicketListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTicketListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketList: async (
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      reportDone?: boolean,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTicketListSideloadEnum>,
      status?: ApiV1ManagementTicketListStatusEnum,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (assigneesAssignee !== undefined) {
        localVarQueryParameter["assignees__assignee"] = assigneesAssignee;
      }

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (coordinatorsCoordinator !== undefined) {
        localVarQueryParameter["coordinators__coordinator"] = coordinatorsCoordinator;
      }

      if (createdBy !== undefined) {
        localVarQueryParameter["created_by"] = createdBy;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (itemsComponentSerialNumber !== undefined) {
        localVarQueryParameter["items__component__serial_number"] =
          itemsComponentSerialNumber;
      }

      if (managersManager !== undefined) {
        localVarQueryParameter["managers__manager"] = managersManager;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (project !== undefined) {
        localVarQueryParameter["project"] = project;
      }

      if (reportDone !== undefined) {
        localVarQueryParameter["report_done"] = reportDone;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (service !== undefined) {
        localVarQueryParameter["service"] = service;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketPartialUpdate: async (
      id: string,
      patchedTicket?: PatchedTicket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketRejectionsList: async (
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket_rejections/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (recipient !== undefined) {
        localVarQueryParameter["recipient"] = recipient;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (sender !== undefined) {
        localVarQueryParameter["sender"] = sender;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTicketRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementTicketRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketRetrieve", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsList: async (
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/ticket-standby-periods/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {PatchedTicketStandbyPeriod} [patchedTicketStandbyPeriod]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsPartialUpdate: async (
      id: string,
      patchedTicketStandbyPeriod?: PatchedTicketStandbyPeriod,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketStandbyPeriodsPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket-standby-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTicketStandbyPeriod,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketStandbyPeriodsRetrieve", "id", id);
      const localVarPath = `/api/v1/management/ticket-standby-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {TicketStandbyPeriodEdit} [ticketStandbyPeriodEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsUpdate: async (
      id: string,
      ticketStandbyPeriodEdit?: TicketStandbyPeriodEdit,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketStandbyPeriodsUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket-standby-periods/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticketStandbyPeriodEdit,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketTicketApprovePartialUpdate: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketTicketApprovePartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/ticket_approve/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedRejectTicket} [patchedRejectTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketTicketRejectPartialUpdate: async (
      id: string,
      patchedRejectTicket?: PatchedRejectTicket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketTicketRejectPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/ticket/{id}/ticket_reject/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedRejectTicket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketUpdate: async (
      id: string,
      ticket: Ticket,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTicketUpdate", "id", id);
      // verify required parameter 'ticket' is not null or undefined
      assertParamExists("apiV1ManagementTicketUpdate", "ticket", ticket);
      const localVarPath = `/api/v1/management/ticket/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ticket,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {PatchedTimeEntryEdit} [patchedTimeEntryEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingEditTimePartialUpdate: async (
      id: string,
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      patchedTimeEntryEdit?: PatchedTimeEntryEdit,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTimeTrackingEditTimePartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/time_tracking/{id}/edit_time/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (assignee !== undefined) {
        localVarQueryParameter["assignee"] = assignee;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      if (ticketItem !== undefined) {
        localVarQueryParameter["ticket_item"] = ticketItem;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTimeEntryEdit,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingList: async (
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/time_tracking/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (assignee !== undefined) {
        localVarQueryParameter["assignee"] = assignee;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      if (ticketItem !== undefined) {
        localVarQueryParameter["ticket_item"] = ticketItem;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTimeTrackingRetrieve", "id", id);
      const localVarPath = `/api/v1/management/time_tracking/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesComponentsList: async (
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'turbineId' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesComponentsList", "turbineId", turbineId);
      const localVarPath = `/api/v1/management/turbines/{turbine_id}/components/`.replace(
        `{${"turbine_id"}}`,
        encodeURIComponent(String(turbineId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesCreate: async (
      turbine: Turbine,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'turbine' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesCreate", "turbine", turbine);
      const localVarPath = `/api/v1/management/turbines/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        turbine,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesDestroy", "id", id);
      const localVarPath = `/api/v1/management/turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesList: async (
      client?: string,
      currentPage?: number,
      location?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTurbinesListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/turbines/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (location !== undefined) {
        localVarQueryParameter["location"] = location;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (serialNumber !== undefined) {
        localVarQueryParameter["serial_number"] = serialNumber;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTurbine} [patchedTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesPartialUpdate: async (
      id: string,
      patchedTurbine?: PatchedTurbine,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedTurbine,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesRetrieve: async (
      id: string,
      sideload?: Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesRetrieve", "id", id);
      const localVarPath = `/api/v1/management/turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesUpdate: async (
      id: string,
      turbine: Turbine,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesUpdate", "id", id);
      // verify required parameter 'turbine' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesUpdate", "turbine", turbine);
      const localVarPath = `/api/v1/management/turbines/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        turbine,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesWorkOrdersList: async (
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'turbineId' is not null or undefined
      assertParamExists("apiV1ManagementTurbinesWorkOrdersList", "turbineId", turbineId);
      const localVarPath =
        `/api/v1/management/turbines/{turbine_id}/work-orders/`.replace(
          `{${"turbine_id"}}`,
          encodeURIComponent(String(turbineId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (sideload) {
        localVarQueryParameter["sideload"] = sideload;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [targetUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserActionWorklogList: async (
      currentPage?: number,
      perPage?: number,
      search?: string,
      targetUser?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/user_action_worklog/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (targetUser !== undefined) {
        localVarQueryParameter["target_user"] = targetUser;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementCreate: async (
      userCreateUpdate: UserCreateUpdate,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userCreateUpdate' is not null or undefined
      assertParamExists(
        "apiV1ManagementUserManagementCreate",
        "userCreateUpdate",
        userCreateUpdate
      );
      const localVarPath = `/api/v1/management/user_management/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementDeactivateUserPartialUpdate: async (
      id: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementUserManagementDeactivateUserPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/user_management/{id}/deactivate_user/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUserManagementDestroy", "id", id);
      const localVarPath = `/api/v1/management/user_management/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUserManagementListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementList: async (
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      ordering?: string,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUserManagementListTechnicianLevelEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/user_management/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (email !== undefined) {
        localVarQueryParameter["email"] = email;
      }

      if (groupsName !== undefined) {
        localVarQueryParameter["groups__name"] = groupsName;
      }

      if (isActive !== undefined) {
        localVarQueryParameter["is_active"] = isActive;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (technicianLevel !== undefined) {
        localVarQueryParameter["technician_level"] = technicianLevel;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {PatchedUserCreateUpdate} [patchedUserCreateUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementPartialUpdate: async (
      id: number,
      patchedUserCreateUpdate?: PatchedUserCreateUpdate,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUserManagementPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/user_management/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUserCreateUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementReactivateUserPartialUpdate: async (
      id: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "apiV1ManagementUserManagementReactivateUserPartialUpdate",
        "id",
        id
      );
      const localVarPath =
        `/api/v1/management/user_management/{id}/reactivate_user/`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUserManagementRetrieve", "id", id);
      const localVarPath = `/api/v1/management/user_management/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementUpdate: async (
      id: number,
      userCreateUpdate: UserCreateUpdate,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUserManagementUpdate", "id", id);
      // verify required parameter 'userCreateUpdate' is not null or undefined
      assertParamExists(
        "apiV1ManagementUserManagementUpdate",
        "userCreateUpdate",
        userCreateUpdate
      );
      const localVarPath = `/api/v1/management/user_management/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {ChangePassword} changePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersChangePasswordCreate: async (
      id: string,
      changePassword: ChangePassword,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUsersChangePasswordCreate", "id", id);
      // verify required parameter 'changePassword' is not null or undefined
      assertParamExists(
        "apiV1ManagementUsersChangePasswordCreate",
        "changePassword",
        changePassword
      );
      const localVarPath = `/api/v1/management/users/{id}/change_password/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePassword,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUsersListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersList: async (
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUsersListTechnicianLevelEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/users/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (email !== undefined) {
        localVarQueryParameter["email"] = email;
      }

      if (groupsName !== undefined) {
        localVarQueryParameter["groups__name"] = groupsName;
      }

      if (isActive !== undefined) {
        localVarQueryParameter["is_active"] = isActive;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (technicianLevel !== undefined) {
        localVarQueryParameter["technician_level"] = technicianLevel;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUsersRetrieve", "id", id);
      const localVarPath = `/api/v1/management/users/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserProfile} [patchedUserProfile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersUpdatePartialUpdate: async (
      id: string,
      patchedUserProfile?: PatchedUserProfile,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementUsersUpdatePartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/users/update/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedUserProfile,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryCreate: async (
      workHistory?: WorkHistory,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/work_history/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        workHistory,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryDestroy: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementWorkHistoryDestroy", "id", id);
      const localVarPath = `/api/v1/management/work_history/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [component]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryList: async (
      component?: string,
      createdBy?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/work_history/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (component !== undefined) {
        localVarQueryParameter["component"] = component;
      }

      if (createdBy !== undefined) {
        localVarQueryParameter["created_by"] = createdBy;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["ordering"] = ordering;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      if (ticket !== undefined) {
        localVarQueryParameter["ticket"] = ticket;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {PatchedWorkHistory} [patchedWorkHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryPartialUpdate: async (
      id: string,
      patchedWorkHistory?: PatchedWorkHistory,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementWorkHistoryPartialUpdate", "id", id);
      const localVarPath = `/api/v1/management/work_history/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchedWorkHistory,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryUpdate: async (
      id: string,
      workHistory?: WorkHistory,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiV1ManagementWorkHistoryUpdate", "id", id);
      const localVarPath = `/api/v1/management/work_history/{id}/`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        workHistory,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [location]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkOrdersMetaRetrieve: async (
      client?: string,
      location?: string,
      turbine?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/management/work-orders/meta/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (client !== undefined) {
        localVarQueryParameter["client"] = client;
      }

      if (location !== undefined) {
        localVarQueryParameter["location"] = location;
      }

      if (turbine !== undefined) {
        localVarQueryParameter["turbine"] = turbine;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorklogList: async (
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists("apiV1ManagementWorklogList", "ticketId", ticketId);
      const localVarPath = `/api/v1/management/worklog/{ticket_id}/`.replace(
        `{${"ticket_id"}}`,
        encodeURIComponent(String(ticketId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} componentId
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorklogList2: async (
      componentId: string,
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'componentId' is not null or undefined
      assertParamExists("apiV1ManagementWorklogList2", "componentId", componentId);
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists("apiV1ManagementWorklogList2", "ticketId", ticketId);
      const localVarPath = `/api/v1/management/worklog/{ticket_id}/{component_id}/`
        .replace(`{${"component_id"}}`, encodeURIComponent(String(componentId)))
        .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication jwtAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (currentPage !== undefined) {
        localVarQueryParameter["current_page"] = currentPage;
      }

      if (perPage !== undefined) {
        localVarQueryParameter["per_page"] = perPage;
      }

      localVarHeaderParameter["Accept"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ApiApi - functional programming interface
 */
export const ApiApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementAuthCheckCredentialsCreate(
      credentials: Credentials,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Challenge>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementAuthCheckCredentialsCreate(
          credentials,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementAuthCheckCredentialsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EmailOTPChallenge} emailOTPChallenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementAuthEmailOtpLoginCreate(
      emailOTPChallenge: EmailOTPChallenge,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPair>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementAuthEmailOtpLoginCreate(
          emailOTPChallenge,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementAuthEmailOtpLoginCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ChallengeWithKey} challengeWithKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementAuthLoginCreate(
      challengeWithKey: ChallengeWithKey,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenObtainPair>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementAuthLoginCreate(
          challengeWithKey,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementAuthLoginCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefresh} tokenRefresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementAuthRefreshCreate(
      tokenRefresh: TokenRefresh,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefresh>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementAuthRefreshCreate(
          tokenRefresh,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementAuthRefreshCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Email} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementAuthResetPasswordCreate(
      email: Email,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementAuthResetPasswordCreate(
          email,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementAuthResetPasswordCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsCreate(
      client: Client,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsCreate(client, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsList(
      currentPage?: number,
      legalName?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsList(
          currentPage,
          legalName,
          ordering,
          perPage,
          search,
          taxId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {PatchedClient} [patchedClient]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsPartialUpdate(
      id: string,
      patchedClient?: PatchedClient,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsPartialUpdate(
          id,
          patchedClient,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementClientsTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsTurbinesList(
      clientId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementClientsTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedclientTurbinesResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsTurbinesList(
          clientId,
          currentPage,
          perPage,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsTurbinesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementClientsUpdate(
      id: string,
      client: Client,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementClientsUpdate(id, client, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementClientsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementComponentsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementComponentsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementComponentsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ApiV1ManagementComponentsListComponentTypeEnum} [componentType] * &#x60;BLADE&#x60; - Blade * &#x60;NACELLE&#x60; - Nacelle * &#x60;HUB&#x60; - Hub * &#x60;TOWER&#x60; - Tower
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [manufacturer]
     * @param {string} [model]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {string} [setNumber]
     * @param {Array<ApiV1ManagementComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementComponentsList(
      componentType?: ApiV1ManagementComponentsListComponentTypeEnum,
      currentPage?: number,
      manufacturer?: string,
      model?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      setNumber?: string,
      sideload?: Array<ApiV1ManagementComponentsListSideloadEnum>,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedcomponentResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementComponentsList(
          componentType,
          currentPage,
          manufacturer,
          model,
          perPage,
          search,
          serialNumber,
          setNumber,
          sideload,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementComponentsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {PatchedTurbineComponent} [patchedTurbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementComponentsPartialUpdate(
      id: string,
      patchedTurbineComponent?: PatchedTurbineComponent,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurbineComponent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementComponentsPartialUpdate(
          id,
          patchedTurbineComponent,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementComponentsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {Array<ApiV1ManagementComponentsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementComponentsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementComponentsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurbineComponentRetrieve>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementComponentsRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementComponentsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {TurbineComponent} [turbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementComponentsUpdate(
      id: string,
      turbineComponent?: TurbineComponent,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurbineComponent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementComponentsUpdate(
          id,
          turbineComponent,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementComponentsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementDashboardRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardSummary>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementDashboardRetrieve(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementDashboardRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [file]
     * @param {string} [location]
     * @param {string} [material]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [ticketItem]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementEntityWorklogList(
      client?: string,
      component?: string,
      currentPage?: number,
      file?: string,
      location?: string,
      material?: string,
      perPage?: number,
      project?: string,
      ticketItem?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWorkLogList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementEntityWorklogList(
          client,
          component,
          currentPage,
          file,
          location,
          material,
          perPage,
          project,
          ticketItem,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementEntityWorklogList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFileRelationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFileRelationsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFileRelationsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFileRelationsList(
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedFileRelationsList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFileRelationsList(
          currentPage,
          perPage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFileRelationsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {PatchedFileRelations} [patchedFileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFileRelationsPartialUpdate(
      id: string,
      patchedFileRelations?: PatchedFileRelations,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileRelations>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFileRelationsPartialUpdate(
          id,
          patchedFileRelations,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFileRelationsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFileRelationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileRelations>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFileRelationsRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFileRelationsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {FileRelations} [fileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFileRelationsUpdate(
      id: string,
      fileRelations?: FileRelations,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileRelations>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFileRelationsUpdate(
          id,
          fileRelations,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFileRelationsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} file
     * @param {Attachment} metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFilesCreate(
      file: string,
      metadata: Attachment,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFilesCreate(
          file,
          metadata,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFilesCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this file model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFilesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFilesDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFilesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFilesDownloadRetrieve(
      id: string,
      token?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFilesDownloadRetrieve(
          id,
          token,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFilesDownloadRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {ApiV1ManagementFilesListFileRelationsPurposeEnum} [fileRelationsPurpose] * &#x60;PLACEHOLDER1&#x60; - Placeholder 1 * &#x60;PLACEHOLDER2&#x60; - Placeholder 2 * &#x60;PLACEHOLDER3&#x60; - Placeholder 3
     * @param {string} [fileRelationsTicket]
     * @param {number} [fileRelationsUploadedBy]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFilesList(
      currentPage?: number,
      fileRelationsPurpose?: ApiV1ManagementFilesListFileRelationsPurposeEnum,
      fileRelationsTicket?: string,
      fileRelationsUploadedBy?: number,
      ordering?: string,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFileList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManagementFilesList(
        currentPage,
        fileRelationsPurpose,
        fileRelationsTicket,
        fileRelationsUploadedBy,
        ordering,
        perPage,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFilesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementFilesThumbnailRetrieve(
      id: string,
      token?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementFilesThumbnailRetrieve(
          id,
          token,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementFilesThumbnailRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [material]
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementGlobalNotificationsList(
      client?: string,
      component?: string,
      currentPage?: number,
      location?: string,
      material?: string,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      project?: string,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedNotificationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementGlobalNotificationsList(
          client,
          component,
          currentPage,
          location,
          material,
          notificationType,
          ordering,
          perPage,
          project,
          recipient,
          search,
          sender,
          ticket,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementGlobalNotificationsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsCreate(
      location: Location,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsCreate(location, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLocationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsList(
          currentPage,
          ordering,
          perPage,
          search,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {PatchedLocation} [patchedLocation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsPartialUpdate(
      id: string,
      patchedLocation?: PatchedLocation,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsPartialUpdate(
          id,
          patchedLocation,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLocationsUpdate(
      id: string,
      location: Location,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLocationsUpdate(
          id,
          location,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLocationsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {TOTPToken} tOTPToken
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLoginConfirmMfaKeyCreate(
      tOTPToken: TOTPToken,
      secret?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLoginConfirmMfaKeyCreate(
          tOTPToken,
          secret,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLoginConfirmMfaKeyCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLoginGetMfaKeyRetrieve(
      secret?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtpKey>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLoginGetMfaKeyRetrieve(
          secret,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLoginGetMfaKeyRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Password} password
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementLoginSetPasswordCreate(
      password: Password,
      secret?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementLoginSetPasswordCreate(
          password,
          secret,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementLoginSetPasswordCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsCreate(
      materials: Materials,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Materials>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsCreate(
          materials,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ApiV1ManagementMaterialsListCategoryEnum} [category] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [sapCode]
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsList(
      category?: ApiV1ManagementMaterialsListCategoryEnum,
      currentPage?: number,
      name?: string,
      perPage?: number,
      sapCode?: string,
      search?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMaterialsList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsList(
          category,
          currentPage,
          name,
          perPage,
          sapCode,
          search,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {PatchedMaterials} [patchedMaterials]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsPartialUpdate(
      id: string,
      patchedMaterials?: PatchedMaterials,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Materials>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsPartialUpdate(
          id,
          patchedMaterials,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Materials>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMaterialsUpdate(
      id: string,
      materials: Materials,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Materials>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMaterialsUpdate(
          id,
          materials,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMaterialsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMeRetrieve(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUser>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMeRetrieve(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMeRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMetaCategoriesList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMetaCategoriesList(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMetaCategoriesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMetaGroupsList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroup>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMetaGroupsList(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMetaGroupsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMetaProjectStatusesList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectStatus>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMetaProjectStatusesList(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMetaProjectStatusesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementMetaTicketStatusesList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Status>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementMetaTicketStatusesList(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementMetaTicketStatusesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementNotificationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementNotificationsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementNotificationsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementNotificationsList(
      currentPage?: number,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedNotificationListList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementNotificationsList(
          currentPage,
          notificationType,
          ordering,
          perPage,
          search,
          sender,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementNotificationsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementNotificationsMarkAllAsReadPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementNotificationsMarkAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementNotificationsMarkAsReadPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementNotificationsMarkAsReadPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsCreate(
      project?: Project,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsCreate(project, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsList(
      client?: string,
      currentPage?: number,
      name?: string,
      ordering?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementProjectsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProjectList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsList(
          client,
          currentPage,
          name,
          ordering,
          perPage,
          projectStatus,
          search,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {PatchedProject} [patchedProject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsPartialUpdate(
      id: string,
      patchedProject?: PatchedProject,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsPartialUpdate(
          id,
          patchedProject,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementProjectsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetailed>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementProjectsUpdate(
      id: string,
      project?: Project,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementProjectsUpdate(
          id,
          project,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementProjectsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {ApiV1ManagementSchemaRetrieveFormatEnum} [format]
     * @param {ApiV1ManagementSchemaRetrieveLangEnum} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementSchemaRetrieve(
      format?: ApiV1ManagementSchemaRetrieveFormatEnum,
      lang?: ApiV1ManagementSchemaRetrieveLangEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementSchemaRetrieve(
          format,
          lang,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementSchemaRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesCreate(
      services: Services,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Services>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesCreate(services, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesList(
      currentPage?: number,
      name?: string,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedServicesList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesList(
          currentPage,
          name,
          perPage,
          search,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {PatchedServices} [patchedServices]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesPartialUpdate(
      id: string,
      patchedServices?: PatchedServices,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Services>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesPartialUpdate(
          id,
          patchedServices,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Services>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementServicesUpdate(
      id: string,
      services: Services,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Services>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementServicesUpdate(
          id,
          services,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementServicesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechClientsList(
      currentPage?: number,
      legalName?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedClientList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechClientsList(
          currentPage,
          legalName,
          perPage,
          search,
          taxId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechClientsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechLocationsList(
      currentPage?: number,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLocationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechLocationsList(
          currentPage,
          perPage,
          search,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechLocationsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Location>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechLocationsRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechLocationsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementTechProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementTechProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechProjectsList(
      client?: string,
      currentPage?: number,
      name?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementTechProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementTechProjectsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProjectList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechProjectsList(
          client,
          currentPage,
          name,
          perPage,
          projectStatus,
          search,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechProjectsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechProjectsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDetailed>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechProjectsRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechProjectsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTechTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechTurbinesList(
      client?: string,
      currentPage?: number,
      location?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTechTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedtechnicianTurbineResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechTurbinesList(
          client,
          currentPage,
          location,
          perPage,
          search,
          serialNumber,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechTurbinesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTechnicianTurbine} [patchedTechnicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechTurbinesPartialUpdate(
      id: string,
      patchedTechnicianTurbine?: PatchedTechnicianTurbine,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnicianTurbine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechTurbinesPartialUpdate(
          id,
          patchedTechnicianTurbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechTurbinesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechTurbinesRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurbineRetrieve>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechTurbinesRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechTurbinesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {TechnicianTurbine} [technicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechTurbinesUpdate(
      id: string,
      technicianTurbine?: TechnicianTurbine,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnicianTurbine>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechTurbinesUpdate(
          id,
          technicianTurbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechTurbinesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckIn} checkIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersCheckInCreate(
      id: string,
      checkIn: CheckIn,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIn>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersCheckInCreate(
          id,
          checkIn,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersCheckInCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckOutDatetime} checkOutDatetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersCheckOutCreate(
      id: string,
      checkOutDatetime: CheckOutDatetime,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckOutDatetime>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersCheckOutCreate(
          id,
          checkOutDatetime,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersCheckOutCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest} [apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
      id: string,
      apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest?: ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
          id,
          apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersEndPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTechnicianWorkOrdersListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersList(
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>,
      status?: ApiV1ManagementTechnicianWorkOrdersListStatusEnum,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedtechnicianTicketResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersList(
          assigneesAssignee,
          client,
          coordinatorsCoordinator,
          createdBy,
          currentPage,
          itemsComponentSerialNumber,
          managersManager,
          ordering,
          perPage,
          project,
          search,
          service,
          sideload,
          status,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [batch]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [material]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum} [materialCategory] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {string} [materialName]
     * @param {string} [materialSapCode]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum} [measurementUnit] * &#x60;KG&#x60; - kg * &#x60;G&#x60; - g * &#x60;L&#x60; - L * &#x60;ML&#x60; - ml * &#x60;M2&#x60; - m² * &#x60;EACH&#x60; - each
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersMaterialsList(
      batch?: string,
      currentPage?: number,
      material?: string,
      materialCategory?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum,
      materialName?: string,
      materialSapCode?: string,
      measurementUnit?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum,
      ordering?: string,
      perPage?: number,
      search?: string,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedTicketMaterialsUsageList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersMaterialsList(
          batch,
          currentPage,
          material,
          materialCategory,
          materialName,
          materialSapCode,
          measurementUnit,
          ordering,
          perPage,
          search,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersMaterialsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {PatchedTicketMaterialsUsage} [patchedTicketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
      id: string,
      patchedTicketMaterialsUsage?: PatchedTicketMaterialsUsage,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketMaterialsUsage>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
          id,
          patchedTicketMaterialsUsage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketMaterialsUsage>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {TicketMaterialsUsage} [ticketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
      id: string,
      ticketMaterialsUsage?: TicketMaterialsUsage,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketMaterialsUsage>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
          id,
          ticketMaterialsUsage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersMaterialsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersPartialUpdate(
      id: string,
      patchedTicket?: PatchedTicket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersPartialUpdate(
          id,
          patchedTicket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedReportDelay} [patchedReportDelay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
      id: string,
      patchedReportDelay?: PatchedReportDelay,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
          id,
          patchedReportDelay,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketRetrieve>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersStartPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ManualTimeLog} manualTimeLog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
      id: string,
      manualTimeLog: ManualTimeLog,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
          id,
          manualTimeLog,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTechnicianWorkOrdersUpdate(
      id: string,
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTechnicianWorkOrdersUpdate(
          id,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTechnicianWorkOrdersUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicketIndexRequest} [patchedTicketIndexRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketAssignIndexPartialUpdate(
      id: string,
      patchedTicketIndexRequest?: PatchedTicketIndexRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketAssignIndexPartialUpdate(
          id,
          patchedTicketIndexRequest,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketAssignIndexPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {TicketCommentReaction} ticketCommentReaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentReactionsCreate(
      ticketCommentReaction: TicketCommentReaction,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketCommentReaction>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentReactionsCreate(
          ticketCommentReaction,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentReactionsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment reaction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentReactionsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentReactionsDestroy(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentReactionsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentsCreate(
      ticketComment?: TicketComment,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketComment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentsCreate(
          ticketComment,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentsCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentsDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [replyTo]
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {number} [user]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      replyTo?: number,
      ticket?: string,
      ticketItem?: string,
      user?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedTicketCommentDetailedList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentsList(
          currentPage,
          ordering,
          perPage,
          replyTo,
          ticket,
          ticketItem,
          user,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {PatchedTicketComment} [patchedTicketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentsPartialUpdate(
      id: string,
      patchedTicketComment?: PatchedTicketComment,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketComment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentsPartialUpdate(
          id,
          patchedTicketComment,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCommentsUpdate(
      id: string,
      ticketComment?: TicketComment,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketComment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCommentsUpdate(
          id,
          ticketComment,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCommentsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketCreate(
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketCreate(ticket, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketDelaysList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedNotificationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketDelaysList(
          currentPage,
          ordering,
          perPage,
          recipient,
          search,
          sender,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketDelaysList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {boolean} [reportDone]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTicketListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTicketListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketList(
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      reportDone?: boolean,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTicketListSideloadEnum>,
      status?: ApiV1ManagementTicketListStatusEnum,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedticketResultsSideloadList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManagementTicketList(
        assigneesAssignee,
        client,
        coordinatorsCoordinator,
        createdBy,
        currentPage,
        itemsComponentSerialNumber,
        managersManager,
        ordering,
        perPage,
        project,
        reportDone,
        search,
        service,
        sideload,
        status,
        turbine,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketPartialUpdate(
      id: string,
      patchedTicket?: PatchedTicket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketPartialUpdate(
          id,
          patchedTicket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketRejectionsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedNotificationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketRejectionsList(
          currentPage,
          ordering,
          perPage,
          recipient,
          search,
          sender,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketRejectionsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTicketRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTicketRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketRetrieve>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketStandbyPeriodsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedTicketStandbyPeriodList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketStandbyPeriodsList(
          currentPage,
          ordering,
          perPage,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketStandbyPeriodsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {PatchedTicketStandbyPeriod} [patchedTicketStandbyPeriod]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketStandbyPeriodsPartialUpdate(
      id: string,
      patchedTicketStandbyPeriod?: PatchedTicketStandbyPeriod,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketStandbyPeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketStandbyPeriodsPartialUpdate(
          id,
          patchedTicketStandbyPeriod,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketStandbyPeriodsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketStandbyPeriodsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketStandbyPeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketStandbyPeriodsRetrieve(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketStandbyPeriodsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {TicketStandbyPeriodEdit} [ticketStandbyPeriodEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketStandbyPeriodsUpdate(
      id: string,
      ticketStandbyPeriodEdit?: TicketStandbyPeriodEdit,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketStandbyPeriod>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketStandbyPeriodsUpdate(
          id,
          ticketStandbyPeriodEdit,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketStandbyPeriodsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketTicketApprovePartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketTicketApprovePartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketTicketApprovePartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedRejectTicket} [patchedRejectTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketTicketRejectPartialUpdate(
      id: string,
      patchedRejectTicket?: PatchedRejectTicket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketTicketRejectPartialUpdate(
          id,
          patchedRejectTicket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketTicketRejectPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTicketUpdate(
      id: string,
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTicketUpdate(id, ticket, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTicketUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {PatchedTimeEntryEdit} [patchedTimeEntryEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTimeTrackingEditTimePartialUpdate(
      id: string,
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      patchedTimeEntryEdit?: PatchedTimeEntryEdit,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedTimeTrackingList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTimeTrackingEditTimePartialUpdate(
          id,
          assignee,
          currentPage,
          ordering,
          perPage,
          ticket,
          ticketItem,
          patchedTimeEntryEdit,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTimeTrackingEditTimePartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTimeTrackingList(
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedTimeTrackingList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTimeTrackingList(
          assignee,
          currentPage,
          ordering,
          perPage,
          ticket,
          ticketItem,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTimeTrackingList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTimeTrackingRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTracking>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTimeTrackingRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTimeTrackingRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesComponentsList(
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedturbineComponentResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesComponentsList(
          turbineId,
          currentPage,
          perPage,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesComponentsList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesCreate(
      turbine: Turbine,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Turbine>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesCreate(turbine, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesList(
      client?: string,
      currentPage?: number,
      location?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedturbineResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesList(
          client,
          currentPage,
          location,
          ordering,
          perPage,
          search,
          serialNumber,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTurbine} [patchedTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesPartialUpdate(
      id: string,
      patchedTurbine?: PatchedTurbine,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Turbine>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesPartialUpdate(
          id,
          patchedTurbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurbineRetrieve>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesRetrieve(
          id,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesUpdate(
      id: string,
      turbine: Turbine,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Turbine>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesUpdate(
          id,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementTurbinesWorkOrdersList(
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedturbineWoResultsSideloadList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementTurbinesWorkOrdersList(
          turbineId,
          currentPage,
          perPage,
          sideload,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementTurbinesWorkOrdersList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [targetUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserActionWorklogList(
      currentPage?: number,
      perPage?: number,
      search?: string,
      targetUser?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWorkLogList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserActionWorklogList(
          currentPage,
          perPage,
          search,
          targetUser,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserActionWorklogList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementCreate(
      userCreateUpdate: UserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUpdate>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementCreate(
          userCreateUpdate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementDeactivateUserPartialUpdate(
      id: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementDeactivateUserPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementUserManagementDeactivateUserPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementDestroy(
      id: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUserManagementListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementList(
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      ordering?: string,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUserManagementListTechnicianLevelEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementList(
          currentPage,
          email,
          groupsName,
          isActive,
          ordering,
          perPage,
          search,
          technicianLevel,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {PatchedUserCreateUpdate} [patchedUserCreateUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementPartialUpdate(
      id: number,
      patchedUserCreateUpdate?: PatchedUserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUpdate>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementPartialUpdate(
          id,
          patchedUserCreateUpdate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementReactivateUserPartialUpdate(
      id: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementReactivateUserPartialUpdate(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ApiApi.apiV1ManagementUserManagementReactivateUserPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementRetrieve(
      id: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementRetrieve(
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUserManagementUpdate(
      id: number,
      userCreateUpdate: UserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUpdate>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUserManagementUpdate(
          id,
          userCreateUpdate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUserManagementUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {ChangePassword} changePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUsersChangePasswordCreate(
      id: string,
      changePassword: ChangePassword,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUsersChangePasswordCreate(
          id,
          changePassword,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUsersChangePasswordCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUsersListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUsersList(
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUsersListTechnicianLevelEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserProfileList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManagementUsersList(
        currentPage,
        email,
        groupsName,
        isActive,
        perPage,
        search,
        technicianLevel,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUsersList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUsersRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUsersRetrieve(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUsersRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserProfile} [patchedUserProfile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementUsersUpdatePartialUpdate(
      id: string,
      patchedUserProfile?: PatchedUserProfile,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementUsersUpdatePartialUpdate(
          id,
          patchedUserProfile,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementUsersUpdatePartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkHistoryCreate(
      workHistory?: WorkHistory,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkHistory>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkHistoryCreate(
          workHistory,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkHistoryCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkHistoryDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkHistoryDestroy(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkHistoryDestroy"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [component]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkHistoryList(
      component?: string,
      createdBy?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedWorkHistoryDetailedList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkHistoryList(
          component,
          createdBy,
          currentPage,
          ordering,
          perPage,
          ticket,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkHistoryList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {PatchedWorkHistory} [patchedWorkHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkHistoryPartialUpdate(
      id: string,
      patchedWorkHistory?: PatchedWorkHistory,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkHistory>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkHistoryPartialUpdate(
          id,
          patchedWorkHistory,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkHistoryPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkHistoryUpdate(
      id: string,
      workHistory?: WorkHistory,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkHistory>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkHistoryUpdate(
          id,
          workHistory,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkHistoryUpdate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [location]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorkOrdersMetaRetrieve(
      client?: string,
      location?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketData>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorkOrdersMetaRetrieve(
          client,
          location,
          turbine,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorkOrdersMetaRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorklogList(
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWorkLogList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorklogList(
          ticketId,
          currentPage,
          perPage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorklogList"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} componentId
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ManagementWorklogList2(
      componentId: string,
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedWorkLogList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ManagementWorklogList2(
          componentId,
          ticketId,
          currentPage,
          perPage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ApiApi.apiV1ManagementWorklogList2"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ApiApi - factory interface
 */
export const ApiApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ApiApiFp(configuration);
  return {
    /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthCheckCredentialsCreate(
      credentials: Credentials,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Challenge> {
      return localVarFp
        .apiV1ManagementAuthCheckCredentialsCreate(credentials, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EmailOTPChallenge} emailOTPChallenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthEmailOtpLoginCreate(
      emailOTPChallenge: EmailOTPChallenge,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenObtainPair> {
      return localVarFp
        .apiV1ManagementAuthEmailOtpLoginCreate(emailOTPChallenge, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ChallengeWithKey} challengeWithKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthLoginCreate(
      challengeWithKey: ChallengeWithKey,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenObtainPair> {
      return localVarFp
        .apiV1ManagementAuthLoginCreate(challengeWithKey, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefresh} tokenRefresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthRefreshCreate(
      tokenRefresh: TokenRefresh,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenRefresh> {
      return localVarFp
        .apiV1ManagementAuthRefreshCreate(tokenRefresh, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Email} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementAuthResetPasswordCreate(
      email: Email,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementAuthResetPasswordCreate(email, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsCreate(
      client: Client,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Client> {
      return localVarFp
        .apiV1ManagementClientsCreate(client, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementClientsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsList(
      currentPage?: number,
      legalName?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedClientList> {
      return localVarFp
        .apiV1ManagementClientsList(
          currentPage,
          legalName,
          ordering,
          perPage,
          search,
          taxId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {PatchedClient} [patchedClient]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsPartialUpdate(
      id: string,
      patchedClient?: PatchedClient,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Client> {
      return localVarFp
        .apiV1ManagementClientsPartialUpdate(id, patchedClient, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Client> {
      return localVarFp
        .apiV1ManagementClientsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementClientsTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsTurbinesList(
      clientId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementClientsTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedclientTurbinesResultsSideloadList> {
      return localVarFp
        .apiV1ManagementClientsTurbinesList(
          clientId,
          currentPage,
          perPage,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this client model.
     * @param {Client} client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementClientsUpdate(
      id: string,
      client: Client,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Client> {
      return localVarFp
        .apiV1ManagementClientsUpdate(id, client, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementComponentsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ApiV1ManagementComponentsListComponentTypeEnum} [componentType] * &#x60;BLADE&#x60; - Blade * &#x60;NACELLE&#x60; - Nacelle * &#x60;HUB&#x60; - Hub * &#x60;TOWER&#x60; - Tower
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [manufacturer]
     * @param {string} [model]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {string} [setNumber]
     * @param {Array<ApiV1ManagementComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsList(
      componentType?: ApiV1ManagementComponentsListComponentTypeEnum,
      currentPage?: number,
      manufacturer?: string,
      model?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      setNumber?: string,
      sideload?: Array<ApiV1ManagementComponentsListSideloadEnum>,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedcomponentResultsSideloadList> {
      return localVarFp
        .apiV1ManagementComponentsList(
          componentType,
          currentPage,
          manufacturer,
          model,
          perPage,
          search,
          serialNumber,
          setNumber,
          sideload,
          turbine,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {PatchedTurbineComponent} [patchedTurbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsPartialUpdate(
      id: string,
      patchedTurbineComponent?: PatchedTurbineComponent,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TurbineComponent> {
      return localVarFp
        .apiV1ManagementComponentsPartialUpdate(id, patchedTurbineComponent, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {Array<ApiV1ManagementComponentsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementComponentsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TurbineComponentRetrieve> {
      return localVarFp
        .apiV1ManagementComponentsRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine component.
     * @param {TurbineComponent} [turbineComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementComponentsUpdate(
      id: string,
      turbineComponent?: TurbineComponent,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TurbineComponent> {
      return localVarFp
        .apiV1ManagementComponentsUpdate(id, turbineComponent, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementDashboardRetrieve(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DashboardSummary> {
      return localVarFp
        .apiV1ManagementDashboardRetrieve(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [file]
     * @param {string} [location]
     * @param {string} [material]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [ticketItem]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementEntityWorklogList(
      client?: string,
      component?: string,
      currentPage?: number,
      file?: string,
      location?: string,
      material?: string,
      perPage?: number,
      project?: string,
      ticketItem?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkLogList> {
      return localVarFp
        .apiV1ManagementEntityWorklogList(
          client,
          component,
          currentPage,
          file,
          location,
          material,
          perPage,
          project,
          ticketItem,
          turbine,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementFileRelationsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsList(
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedFileRelationsList> {
      return localVarFp
        .apiV1ManagementFileRelationsList(currentPage, perPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {PatchedFileRelations} [patchedFileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsPartialUpdate(
      id: string,
      patchedFileRelations?: PatchedFileRelations,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FileRelations> {
      return localVarFp
        .apiV1ManagementFileRelationsPartialUpdate(id, patchedFileRelations, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FileRelations> {
      return localVarFp
        .apiV1ManagementFileRelationsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this files relations model.
     * @param {FileRelations} [fileRelations]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFileRelationsUpdate(
      id: string,
      fileRelations?: FileRelations,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FileRelations> {
      return localVarFp
        .apiV1ManagementFileRelationsUpdate(id, fileRelations, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} file
     * @param {Attachment} metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesCreate(
      file: string,
      metadata: Attachment,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<any> {
      return localVarFp
        .apiV1ManagementFilesCreate(file, metadata, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this file model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementFilesDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesDownloadRetrieve(
      id: string,
      token?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .apiV1ManagementFilesDownloadRetrieve(id, token, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {ApiV1ManagementFilesListFileRelationsPurposeEnum} [fileRelationsPurpose] * &#x60;PLACEHOLDER1&#x60; - Placeholder 1 * &#x60;PLACEHOLDER2&#x60; - Placeholder 2 * &#x60;PLACEHOLDER3&#x60; - Placeholder 3
     * @param {string} [fileRelationsTicket]
     * @param {number} [fileRelationsUploadedBy]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesList(
      currentPage?: number,
      fileRelationsPurpose?: ApiV1ManagementFilesListFileRelationsPurposeEnum,
      fileRelationsTicket?: string,
      fileRelationsUploadedBy?: number,
      ordering?: string,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedFileList> {
      return localVarFp
        .apiV1ManagementFilesList(
          currentPage,
          fileRelationsPurpose,
          fileRelationsTicket,
          fileRelationsUploadedBy,
          ordering,
          perPage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementFilesThumbnailRetrieve(
      id: string,
      token?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .apiV1ManagementFilesThumbnailRetrieve(id, token, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [component]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [material]
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementGlobalNotificationsList(
      client?: string,
      component?: string,
      currentPage?: number,
      location?: string,
      material?: string,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      project?: string,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedNotificationList> {
      return localVarFp
        .apiV1ManagementGlobalNotificationsList(
          client,
          component,
          currentPage,
          location,
          material,
          notificationType,
          ordering,
          perPage,
          project,
          recipient,
          search,
          sender,
          ticket,
          turbine,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsCreate(
      location: Location,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .apiV1ManagementLocationsCreate(location, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementLocationsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedLocationList> {
      return localVarFp
        .apiV1ManagementLocationsList(currentPage, ordering, perPage, search, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {PatchedLocation} [patchedLocation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsPartialUpdate(
      id: string,
      patchedLocation?: PatchedLocation,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .apiV1ManagementLocationsPartialUpdate(id, patchedLocation, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .apiV1ManagementLocationsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {Location} location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLocationsUpdate(
      id: string,
      location: Location,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .apiV1ManagementLocationsUpdate(id, location, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TOTPToken} tOTPToken
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginConfirmMfaKeyCreate(
      tOTPToken: TOTPToken,
      secret?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementLoginConfirmMfaKeyCreate(tOTPToken, secret, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginGetMfaKeyRetrieve(
      secret?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<OtpKey> {
      return localVarFp
        .apiV1ManagementLoginGetMfaKeyRetrieve(secret, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Password} password
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementLoginSetPasswordCreate(
      password: Password,
      secret?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementLoginSetPasswordCreate(password, secret, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsCreate(
      materials: Materials,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Materials> {
      return localVarFp
        .apiV1ManagementMaterialsCreate(materials, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementMaterialsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ApiV1ManagementMaterialsListCategoryEnum} [category] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [sapCode]
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsList(
      category?: ApiV1ManagementMaterialsListCategoryEnum,
      currentPage?: number,
      name?: string,
      perPage?: number,
      sapCode?: string,
      search?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedMaterialsList> {
      return localVarFp
        .apiV1ManagementMaterialsList(
          category,
          currentPage,
          name,
          perPage,
          sapCode,
          search,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {PatchedMaterials} [patchedMaterials]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsPartialUpdate(
      id: string,
      patchedMaterials?: PatchedMaterials,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Materials> {
      return localVarFp
        .apiV1ManagementMaterialsPartialUpdate(id, patchedMaterials, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Materials> {
      return localVarFp
        .apiV1ManagementMaterialsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this materials model.
     * @param {Materials} materials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMaterialsUpdate(
      id: string,
      materials: Materials,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Materials> {
      return localVarFp
        .apiV1ManagementMaterialsUpdate(id, materials, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMeRetrieve(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CurrentUser> {
      return localVarFp
        .apiV1ManagementMeRetrieve(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaCategoriesList(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Category>> {
      return localVarFp
        .apiV1ManagementMetaCategoriesList(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaGroupsList(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<UserGroup>> {
      return localVarFp
        .apiV1ManagementMetaGroupsList(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaProjectStatusesList(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ProjectStatus>> {
      return localVarFp
        .apiV1ManagementMetaProjectStatusesList(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementMetaTicketStatusesList(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Status>> {
      return localVarFp
        .apiV1ManagementMetaTicketStatusesList(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementNotificationsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [notificationType]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsList(
      currentPage?: number,
      notificationType?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedNotificationListList> {
      return localVarFp
        .apiV1ManagementNotificationsList(
          currentPage,
          notificationType,
          ordering,
          perPage,
          search,
          sender,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this notification model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementNotificationsMarkAsReadPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementNotificationsMarkAsReadPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsCreate(
      project?: Project,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .apiV1ManagementProjectsCreate(project, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementProjectsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsList(
      client?: string,
      currentPage?: number,
      name?: string,
      ordering?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementProjectsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectList> {
      return localVarFp
        .apiV1ManagementProjectsList(
          client,
          currentPage,
          name,
          ordering,
          perPage,
          projectStatus,
          search,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {PatchedProject} [patchedProject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsPartialUpdate(
      id: string,
      patchedProject?: PatchedProject,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .apiV1ManagementProjectsPartialUpdate(id, patchedProject, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementProjectsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDetailed> {
      return localVarFp
        .apiV1ManagementProjectsRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Project} [project]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementProjectsUpdate(
      id: string,
      project?: Project,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Project> {
      return localVarFp
        .apiV1ManagementProjectsUpdate(id, project, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {ApiV1ManagementSchemaRetrieveFormatEnum} [format]
     * @param {ApiV1ManagementSchemaRetrieveLangEnum} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementSchemaRetrieve(
      format?: ApiV1ManagementSchemaRetrieveFormatEnum,
      lang?: ApiV1ManagementSchemaRetrieveLangEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .apiV1ManagementSchemaRetrieve(format, lang, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesCreate(
      services: Services,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Services> {
      return localVarFp
        .apiV1ManagementServicesCreate(services, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementServicesDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesList(
      currentPage?: number,
      name?: string,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedServicesList> {
      return localVarFp
        .apiV1ManagementServicesList(currentPage, name, perPage, search, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {PatchedServices} [patchedServices]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesPartialUpdate(
      id: string,
      patchedServices?: PatchedServices,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Services> {
      return localVarFp
        .apiV1ManagementServicesPartialUpdate(id, patchedServices, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Services> {
      return localVarFp
        .apiV1ManagementServicesRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this services model.
     * @param {Services} services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementServicesUpdate(
      id: string,
      services: Services,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Services> {
      return localVarFp
        .apiV1ManagementServicesUpdate(id, services, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [legalName]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [taxId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechClientsList(
      currentPage?: number,
      legalName?: string,
      perPage?: number,
      search?: string,
      taxId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedClientList> {
      return localVarFp
        .apiV1ManagementTechClientsList(
          currentPage,
          legalName,
          perPage,
          search,
          taxId,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechLocationsList(
      currentPage?: number,
      perPage?: number,
      search?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedLocationList> {
      return localVarFp
        .apiV1ManagementTechLocationsList(currentPage, perPage, search, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this location model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechLocationsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Location> {
      return localVarFp
        .apiV1ManagementTechLocationsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [name]
     * @param {number} [perPage] Number of results to return per page.
     * @param {ApiV1ManagementTechProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
     * @param {string} [search] A search term.
     * @param {Array<ApiV1ManagementTechProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechProjectsList(
      client?: string,
      currentPage?: number,
      name?: string,
      perPage?: number,
      projectStatus?: ApiV1ManagementTechProjectsListProjectStatusEnum,
      search?: string,
      sideload?: Array<ApiV1ManagementTechProjectsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedProjectList> {
      return localVarFp
        .apiV1ManagementTechProjectsList(
          client,
          currentPage,
          name,
          perPage,
          projectStatus,
          search,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this project model.
     * @param {Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechProjectsRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDetailed> {
      return localVarFp
        .apiV1ManagementTechProjectsRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTechTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesList(
      client?: string,
      currentPage?: number,
      location?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTechTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedtechnicianTurbineResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTechTurbinesList(
          client,
          currentPage,
          location,
          perPage,
          search,
          serialNumber,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTechnicianTurbine} [patchedTechnicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesPartialUpdate(
      id: string,
      patchedTechnicianTurbine?: PatchedTechnicianTurbine,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TechnicianTurbine> {
      return localVarFp
        .apiV1ManagementTechTurbinesPartialUpdate(id, patchedTechnicianTurbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TurbineRetrieve> {
      return localVarFp
        .apiV1ManagementTechTurbinesRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {TechnicianTurbine} [technicianTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechTurbinesUpdate(
      id: string,
      technicianTurbine?: TechnicianTurbine,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TechnicianTurbine> {
      return localVarFp
        .apiV1ManagementTechTurbinesUpdate(id, technicianTurbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckIn} checkIn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersCheckInCreate(
      id: string,
      checkIn: CheckIn,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CheckIn> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersCheckInCreate(id, checkIn, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {CheckOutDatetime} checkOutDatetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersCheckOutCreate(
      id: string,
      checkOutDatetime: CheckOutDatetime,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CheckOutDatetime> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersCheckOutCreate(id, checkOutDatetime, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest} [apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
      id: string,
      apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest?: ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
          id,
          apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTechnicianWorkOrdersListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersList(
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>,
      status?: ApiV1ManagementTechnicianWorkOrdersListStatusEnum,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedtechnicianTicketResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersList(
          assigneesAssignee,
          client,
          coordinatorsCoordinator,
          createdBy,
          currentPage,
          itemsComponentSerialNumber,
          managersManager,
          ordering,
          perPage,
          project,
          search,
          service,
          sideload,
          status,
          turbine,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [batch]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [material]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum} [materialCategory] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
     * @param {string} [materialName]
     * @param {string} [materialSapCode]
     * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum} [measurementUnit] * &#x60;KG&#x60; - kg * &#x60;G&#x60; - g * &#x60;L&#x60; - L * &#x60;ML&#x60; - ml * &#x60;M2&#x60; - m² * &#x60;EACH&#x60; - each
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsList(
      batch?: string,
      currentPage?: number,
      material?: string,
      materialCategory?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum,
      materialName?: string,
      materialSapCode?: string,
      measurementUnit?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum,
      ordering?: string,
      perPage?: number,
      search?: string,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedTicketMaterialsUsageList> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersMaterialsList(
          batch,
          currentPage,
          material,
          materialCategory,
          materialName,
          materialSapCode,
          measurementUnit,
          ordering,
          perPage,
          search,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {PatchedTicketMaterialsUsage} [patchedTicketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
      id: string,
      patchedTicketMaterialsUsage?: PatchedTicketMaterialsUsage,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketMaterialsUsage> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
          id,
          patchedTicketMaterialsUsage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketMaterialsUsage> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket materials usage.
     * @param {TicketMaterialsUsage} [ticketMaterialsUsage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
      id: string,
      ticketMaterialsUsage?: TicketMaterialsUsage,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketMaterialsUsage> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
          id,
          ticketMaterialsUsage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersPartialUpdate(
      id: string,
      patchedTicket?: PatchedTicket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Ticket> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersPartialUpdate(id, patchedTicket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedReportDelay} [patchedReportDelay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
      id: string,
      patchedReportDelay?: PatchedReportDelay,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
          id,
          patchedReportDelay,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketRetrieve> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {ManualTimeLog} manualTimeLog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
      id: string,
      manualTimeLog: ManualTimeLog,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
          id,
          manualTimeLog,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTechnicianWorkOrdersUpdate(
      id: string,
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Ticket> {
      return localVarFp
        .apiV1ManagementTechnicianWorkOrdersUpdate(id, ticket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicketIndexRequest} [patchedTicketIndexRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketAssignIndexPartialUpdate(
      id: string,
      patchedTicketIndexRequest?: PatchedTicketIndexRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketAssignIndexPartialUpdate(
          id,
          patchedTicketIndexRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TicketCommentReaction} ticketCommentReaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentReactionsCreate(
      ticketCommentReaction: TicketCommentReaction,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketCommentReaction> {
      return localVarFp
        .apiV1ManagementTicketCommentReactionsCreate(ticketCommentReaction, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment reaction.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentReactionsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketCommentReactionsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsCreate(
      ticketComment?: TicketComment,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketComment> {
      return localVarFp
        .apiV1ManagementTicketCommentsCreate(ticketComment, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketCommentsDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [replyTo]
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {number} [user]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      replyTo?: number,
      ticket?: string,
      ticketItem?: string,
      user?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedTicketCommentDetailedList> {
      return localVarFp
        .apiV1ManagementTicketCommentsList(
          currentPage,
          ordering,
          perPage,
          replyTo,
          ticket,
          ticketItem,
          user,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {PatchedTicketComment} [patchedTicketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsPartialUpdate(
      id: string,
      patchedTicketComment?: PatchedTicketComment,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketComment> {
      return localVarFp
        .apiV1ManagementTicketCommentsPartialUpdate(id, patchedTicketComment, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket comment.
     * @param {TicketComment} [ticketComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCommentsUpdate(
      id: string,
      ticketComment?: TicketComment,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketComment> {
      return localVarFp
        .apiV1ManagementTicketCommentsUpdate(id, ticketComment, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketCreate(
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Ticket> {
      return localVarFp
        .apiV1ManagementTicketCreate(ticket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketDelaysList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedNotificationList> {
      return localVarFp
        .apiV1ManagementTicketDelaysList(
          currentPage,
          ordering,
          perPage,
          recipient,
          search,
          sender,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [assigneesAssignee]
     * @param {string} [client]
     * @param {number} [coordinatorsCoordinator]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [itemsComponentSerialNumber]
     * @param {number} [managersManager]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [project]
     * @param {boolean} [reportDone]
     * @param {string} [search] A search term.
     * @param {string} [service]
     * @param {Array<ApiV1ManagementTicketListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {ApiV1ManagementTicketListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketList(
      assigneesAssignee?: number,
      client?: string,
      coordinatorsCoordinator?: number,
      createdBy?: number,
      currentPage?: number,
      itemsComponentSerialNumber?: string,
      managersManager?: number,
      ordering?: string,
      perPage?: number,
      project?: string,
      reportDone?: boolean,
      search?: string,
      service?: string,
      sideload?: Array<ApiV1ManagementTicketListSideloadEnum>,
      status?: ApiV1ManagementTicketListStatusEnum,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedticketResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTicketList(
          assigneesAssignee,
          client,
          coordinatorsCoordinator,
          createdBy,
          currentPage,
          itemsComponentSerialNumber,
          managersManager,
          ordering,
          perPage,
          project,
          reportDone,
          search,
          service,
          sideload,
          status,
          turbine,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedTicket} [patchedTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketPartialUpdate(
      id: string,
      patchedTicket?: PatchedTicket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Ticket> {
      return localVarFp
        .apiV1ManagementTicketPartialUpdate(id, patchedTicket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {number} [recipient]
     * @param {string} [search] A search term.
     * @param {number} [sender]
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketRejectionsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      recipient?: number,
      search?: string,
      sender?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedNotificationList> {
      return localVarFp
        .apiV1ManagementTicketRejectionsList(
          currentPage,
          ordering,
          perPage,
          recipient,
          search,
          sender,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Array<ApiV1ManagementTicketRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTicketRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketRetrieve> {
      return localVarFp
        .apiV1ManagementTicketRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsList(
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedTicketStandbyPeriodList> {
      return localVarFp
        .apiV1ManagementTicketStandbyPeriodsList(
          currentPage,
          ordering,
          perPage,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {PatchedTicketStandbyPeriod} [patchedTicketStandbyPeriod]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsPartialUpdate(
      id: string,
      patchedTicketStandbyPeriod?: PatchedTicketStandbyPeriod,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketStandbyPeriod> {
      return localVarFp
        .apiV1ManagementTicketStandbyPeriodsPartialUpdate(
          id,
          patchedTicketStandbyPeriod,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketStandbyPeriod> {
      return localVarFp
        .apiV1ManagementTicketStandbyPeriodsRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket standby period.
     * @param {TicketStandbyPeriodEdit} [ticketStandbyPeriodEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketStandbyPeriodsUpdate(
      id: string,
      ticketStandbyPeriodEdit?: TicketStandbyPeriodEdit,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketStandbyPeriod> {
      return localVarFp
        .apiV1ManagementTicketStandbyPeriodsUpdate(id, ticketStandbyPeriodEdit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketTicketApprovePartialUpdate(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketTicketApprovePartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {PatchedRejectTicket} [patchedRejectTicket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketTicketRejectPartialUpdate(
      id: string,
      patchedRejectTicket?: PatchedRejectTicket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTicketTicketRejectPartialUpdate(id, patchedRejectTicket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this ticket.
     * @param {Ticket} ticket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTicketUpdate(
      id: string,
      ticket: Ticket,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Ticket> {
      return localVarFp
        .apiV1ManagementTicketUpdate(id, ticket, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {PatchedTimeEntryEdit} [patchedTimeEntryEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingEditTimePartialUpdate(
      id: string,
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      patchedTimeEntryEdit?: PatchedTimeEntryEdit,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedTimeTrackingList> {
      return localVarFp
        .apiV1ManagementTimeTrackingEditTimePartialUpdate(
          id,
          assignee,
          currentPage,
          ordering,
          perPage,
          ticket,
          ticketItem,
          patchedTimeEntryEdit,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [assignee]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {string} [ticketItem]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingList(
      assignee?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      ticketItem?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedTimeTrackingList> {
      return localVarFp
        .apiV1ManagementTimeTrackingList(
          assignee,
          currentPage,
          ordering,
          perPage,
          ticket,
          ticketItem,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this time tracking.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTimeTrackingRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TimeTracking> {
      return localVarFp
        .apiV1ManagementTimeTrackingRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesComponentsList(
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedturbineComponentResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTurbinesComponentsList(
          turbineId,
          currentPage,
          perPage,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesCreate(
      turbine: Turbine,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Turbine> {
      return localVarFp
        .apiV1ManagementTurbinesCreate(turbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementTurbinesDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [location]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [serialNumber]
     * @param {Array<ApiV1ManagementTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesList(
      client?: string,
      currentPage?: number,
      location?: string,
      ordering?: string,
      perPage?: number,
      search?: string,
      serialNumber?: string,
      sideload?: Array<ApiV1ManagementTurbinesListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedturbineResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTurbinesList(
          client,
          currentPage,
          location,
          ordering,
          perPage,
          search,
          serialNumber,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {PatchedTurbine} [patchedTurbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesPartialUpdate(
      id: string,
      patchedTurbine?: PatchedTurbine,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Turbine> {
      return localVarFp
        .apiV1ManagementTurbinesPartialUpdate(id, patchedTurbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesRetrieve(
      id: string,
      sideload?: Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TurbineRetrieve> {
      return localVarFp
        .apiV1ManagementTurbinesRetrieve(id, sideload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this turbine.
     * @param {Turbine} turbine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesUpdate(
      id: string,
      turbine: Turbine,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Turbine> {
      return localVarFp
        .apiV1ManagementTurbinesUpdate(id, turbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} turbineId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementTurbinesWorkOrdersList(
      turbineId: string,
      currentPage?: number,
      perPage?: number,
      sideload?: Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedturbineWoResultsSideloadList> {
      return localVarFp
        .apiV1ManagementTurbinesWorkOrdersList(
          turbineId,
          currentPage,
          perPage,
          sideload,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {number} [targetUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserActionWorklogList(
      currentPage?: number,
      perPage?: number,
      search?: string,
      targetUser?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkLogList> {
      return localVarFp
        .apiV1ManagementUserActionWorklogList(
          currentPage,
          perPage,
          search,
          targetUser,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementCreate(
      userCreateUpdate: UserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserCreateUpdate> {
      return localVarFp
        .apiV1ManagementUserManagementCreate(userCreateUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementDeactivateUserPartialUpdate(
      id: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementUserManagementDeactivateUserPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementDestroy(
      id: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementUserManagementDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUserManagementListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementList(
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      ordering?: string,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUserManagementListTechnicianLevelEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedUserList> {
      return localVarFp
        .apiV1ManagementUserManagementList(
          currentPage,
          email,
          groupsName,
          isActive,
          ordering,
          perPage,
          search,
          technicianLevel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {PatchedUserCreateUpdate} [patchedUserCreateUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementPartialUpdate(
      id: number,
      patchedUserCreateUpdate?: PatchedUserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserCreateUpdate> {
      return localVarFp
        .apiV1ManagementUserManagementPartialUpdate(id, patchedUserCreateUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementReactivateUserPartialUpdate(
      id: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementUserManagementReactivateUserPartialUpdate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementRetrieve(
      id: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<User> {
      return localVarFp
        .apiV1ManagementUserManagementRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id A unique integer value identifying this user.
     * @param {UserCreateUpdate} userCreateUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUserManagementUpdate(
      id: number,
      userCreateUpdate: UserCreateUpdate,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserCreateUpdate> {
      return localVarFp
        .apiV1ManagementUserManagementUpdate(id, userCreateUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {ChangePassword} changePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersChangePasswordCreate(
      id: string,
      changePassword: ChangePassword,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementUsersChangePasswordCreate(id, changePassword, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [email]
     * @param {string} [groupsName]
     * @param {boolean} [isActive]
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {ApiV1ManagementUsersListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersList(
      currentPage?: number,
      email?: string,
      groupsName?: string,
      isActive?: boolean,
      perPage?: number,
      search?: string,
      technicianLevel?: ApiV1ManagementUsersListTechnicianLevelEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedUserProfileList> {
      return localVarFp
        .apiV1ManagementUsersList(
          currentPage,
          email,
          groupsName,
          isActive,
          perPage,
          search,
          technicianLevel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersRetrieve(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserProfile> {
      return localVarFp
        .apiV1ManagementUsersRetrieve(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {PatchedUserProfile} [patchedUserProfile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementUsersUpdatePartialUpdate(
      id: string,
      patchedUserProfile?: PatchedUserProfile,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserProfile> {
      return localVarFp
        .apiV1ManagementUsersUpdatePartialUpdate(id, patchedUserProfile, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryCreate(
      workHistory?: WorkHistory,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkHistory> {
      return localVarFp
        .apiV1ManagementWorkHistoryCreate(workHistory, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryDestroy(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ManagementWorkHistoryDestroy(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [component]
     * @param {number} [createdBy]
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [perPage] Number of results to return per page.
     * @param {string} [ticket]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryList(
      component?: string,
      createdBy?: number,
      currentPage?: number,
      ordering?: string,
      perPage?: number,
      ticket?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkHistoryDetailedList> {
      return localVarFp
        .apiV1ManagementWorkHistoryList(
          component,
          createdBy,
          currentPage,
          ordering,
          perPage,
          ticket,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {PatchedWorkHistory} [patchedWorkHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryPartialUpdate(
      id: string,
      patchedWorkHistory?: PatchedWorkHistory,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkHistory> {
      return localVarFp
        .apiV1ManagementWorkHistoryPartialUpdate(id, patchedWorkHistory, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id A UUID string identifying this work history.
     * @param {WorkHistory} [workHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkHistoryUpdate(
      id: string,
      workHistory?: WorkHistory,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WorkHistory> {
      return localVarFp
        .apiV1ManagementWorkHistoryUpdate(id, workHistory, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [client]
     * @param {string} [location]
     * @param {string} [turbine]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorkOrdersMetaRetrieve(
      client?: string,
      location?: string,
      turbine?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TicketData> {
      return localVarFp
        .apiV1ManagementWorkOrdersMetaRetrieve(client, location, turbine, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorklogList(
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkLogList> {
      return localVarFp
        .apiV1ManagementWorklogList(ticketId, currentPage, perPage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} componentId
     * @param {string} ticketId
     * @param {number} [currentPage] A page number within the paginated result set.
     * @param {number} [perPage] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ManagementWorklogList2(
      componentId: string,
      ticketId: string,
      currentPage?: number,
      perPage?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedWorkLogList> {
      return localVarFp
        .apiV1ManagementWorklogList2(componentId, ticketId, currentPage, perPage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ApiApi - object-oriented interface
 */
export class ApiApi extends BaseAPI {
  /**
   *
   * @param {Credentials} credentials
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementAuthCheckCredentialsCreate(
    credentials: Credentials,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementAuthCheckCredentialsCreate(credentials, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EmailOTPChallenge} emailOTPChallenge
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementAuthEmailOtpLoginCreate(
    emailOTPChallenge: EmailOTPChallenge,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementAuthEmailOtpLoginCreate(emailOTPChallenge, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ChallengeWithKey} challengeWithKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementAuthLoginCreate(
    challengeWithKey: ChallengeWithKey,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementAuthLoginCreate(challengeWithKey, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
   * @param {TokenRefresh} tokenRefresh
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementAuthRefreshCreate(
    tokenRefresh: TokenRefresh,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementAuthRefreshCreate(tokenRefresh, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Email} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementAuthResetPasswordCreate(
    email: Email,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementAuthResetPasswordCreate(email, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Client} client
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsCreate(client: Client, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsCreate(client, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this client model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [legalName]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [taxId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsList(
    currentPage?: number,
    legalName?: string,
    ordering?: string,
    perPage?: number,
    search?: string,
    taxId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsList(
        currentPage,
        legalName,
        ordering,
        perPage,
        search,
        taxId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this client model.
   * @param {PatchedClient} [patchedClient]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsPartialUpdate(
    id: string,
    patchedClient?: PatchedClient,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsPartialUpdate(id, patchedClient, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this client model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} clientId
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {Array<ApiV1ManagementClientsTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsTurbinesList(
    clientId: string,
    currentPage?: number,
    perPage?: number,
    sideload?: Array<ApiV1ManagementClientsTurbinesListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsTurbinesList(
        clientId,
        currentPage,
        perPage,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this client model.
   * @param {Client} client
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementClientsUpdate(
    id: string,
    client: Client,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementClientsUpdate(id, client, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine component.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementComponentsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementComponentsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ApiV1ManagementComponentsListComponentTypeEnum} [componentType] * &#x60;BLADE&#x60; - Blade * &#x60;NACELLE&#x60; - Nacelle * &#x60;HUB&#x60; - Hub * &#x60;TOWER&#x60; - Tower
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [manufacturer]
   * @param {string} [model]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [serialNumber]
   * @param {string} [setNumber]
   * @param {Array<ApiV1ManagementComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementComponentsList(
    componentType?: ApiV1ManagementComponentsListComponentTypeEnum,
    currentPage?: number,
    manufacturer?: string,
    model?: string,
    perPage?: number,
    search?: string,
    serialNumber?: string,
    setNumber?: string,
    sideload?: Array<ApiV1ManagementComponentsListSideloadEnum>,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementComponentsList(
        componentType,
        currentPage,
        manufacturer,
        model,
        perPage,
        search,
        serialNumber,
        setNumber,
        sideload,
        turbine,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine component.
   * @param {PatchedTurbineComponent} [patchedTurbineComponent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementComponentsPartialUpdate(
    id: string,
    patchedTurbineComponent?: PatchedTurbineComponent,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementComponentsPartialUpdate(id, patchedTurbineComponent, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine component.
   * @param {Array<ApiV1ManagementComponentsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementComponentsRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementComponentsRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementComponentsRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine component.
   * @param {TurbineComponent} [turbineComponent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementComponentsUpdate(
    id: string,
    turbineComponent?: TurbineComponent,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementComponentsUpdate(id, turbineComponent, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementDashboardRetrieve(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementDashboardRetrieve(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {string} [component]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [file]
   * @param {string} [location]
   * @param {string} [material]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [project]
   * @param {string} [ticketItem]
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementEntityWorklogList(
    client?: string,
    component?: string,
    currentPage?: number,
    file?: string,
    location?: string,
    material?: string,
    perPage?: number,
    project?: string,
    ticketItem?: string,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementEntityWorklogList(
        client,
        component,
        currentPage,
        file,
        location,
        material,
        perPage,
        project,
        ticketItem,
        turbine,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this files relations model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFileRelationsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFileRelationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFileRelationsList(
    currentPage?: number,
    perPage?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFileRelationsList(currentPage, perPage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this files relations model.
   * @param {PatchedFileRelations} [patchedFileRelations]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFileRelationsPartialUpdate(
    id: string,
    patchedFileRelations?: PatchedFileRelations,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFileRelationsPartialUpdate(id, patchedFileRelations, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this files relations model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFileRelationsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFileRelationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this files relations model.
   * @param {FileRelations} [fileRelations]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFileRelationsUpdate(
    id: string,
    fileRelations?: FileRelations,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFileRelationsUpdate(id, fileRelations, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} file
   * @param {Attachment} metadata
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFilesCreate(
    file: string,
    metadata: Attachment,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFilesCreate(file, metadata, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this file model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFilesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFilesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} [token]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFilesDownloadRetrieve(
    id: string,
    token?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFilesDownloadRetrieve(id, token, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {ApiV1ManagementFilesListFileRelationsPurposeEnum} [fileRelationsPurpose] * &#x60;PLACEHOLDER1&#x60; - Placeholder 1 * &#x60;PLACEHOLDER2&#x60; - Placeholder 2 * &#x60;PLACEHOLDER3&#x60; - Placeholder 3
   * @param {string} [fileRelationsTicket]
   * @param {number} [fileRelationsUploadedBy]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFilesList(
    currentPage?: number,
    fileRelationsPurpose?: ApiV1ManagementFilesListFileRelationsPurposeEnum,
    fileRelationsTicket?: string,
    fileRelationsUploadedBy?: number,
    ordering?: string,
    perPage?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFilesList(
        currentPage,
        fileRelationsPurpose,
        fileRelationsTicket,
        fileRelationsUploadedBy,
        ordering,
        perPage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} [token]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementFilesThumbnailRetrieve(
    id: string,
    token?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementFilesThumbnailRetrieve(id, token, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {string} [component]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [location]
   * @param {string} [material]
   * @param {string} [notificationType]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [project]
   * @param {number} [recipient]
   * @param {string} [search] A search term.
   * @param {number} [sender]
   * @param {string} [ticket]
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementGlobalNotificationsList(
    client?: string,
    component?: string,
    currentPage?: number,
    location?: string,
    material?: string,
    notificationType?: string,
    ordering?: string,
    perPage?: number,
    project?: string,
    recipient?: number,
    search?: string,
    sender?: number,
    ticket?: string,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementGlobalNotificationsList(
        client,
        component,
        currentPage,
        location,
        material,
        notificationType,
        ordering,
        perPage,
        project,
        recipient,
        search,
        sender,
        ticket,
        turbine,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this notification model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementGlobalNotificationsMarkAsReadPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Location} location
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsCreate(
    location: Location,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsCreate(location, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this location model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsList(
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    search?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsList(currentPage, ordering, perPage, search, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this location model.
   * @param {PatchedLocation} [patchedLocation]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsPartialUpdate(
    id: string,
    patchedLocation?: PatchedLocation,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsPartialUpdate(id, patchedLocation, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this location model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this location model.
   * @param {Location} location
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLocationsUpdate(
    id: string,
    location: Location,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLocationsUpdate(id, location, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TOTPToken} tOTPToken
   * @param {string} [secret]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLoginConfirmMfaKeyCreate(
    tOTPToken: TOTPToken,
    secret?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLoginConfirmMfaKeyCreate(tOTPToken, secret, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [secret]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLoginGetMfaKeyRetrieve(
    secret?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLoginGetMfaKeyRetrieve(secret, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Password} password
   * @param {string} [secret]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementLoginSetPasswordCreate(
    password: Password,
    secret?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementLoginSetPasswordCreate(password, secret, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Materials} materials
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsCreate(
    materials: Materials,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsCreate(materials, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this materials model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ApiV1ManagementMaterialsListCategoryEnum} [category] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [name]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [sapCode]
   * @param {string} [search] A search term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsList(
    category?: ApiV1ManagementMaterialsListCategoryEnum,
    currentPage?: number,
    name?: string,
    perPage?: number,
    sapCode?: string,
    search?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsList(
        category,
        currentPage,
        name,
        perPage,
        sapCode,
        search,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this materials model.
   * @param {PatchedMaterials} [patchedMaterials]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsPartialUpdate(
    id: string,
    patchedMaterials?: PatchedMaterials,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsPartialUpdate(id, patchedMaterials, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this materials model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this materials model.
   * @param {Materials} materials
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMaterialsUpdate(
    id: string,
    materials: Materials,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMaterialsUpdate(id, materials, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMeRetrieve(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMeRetrieve(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMetaCategoriesList(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMetaCategoriesList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMetaGroupsList(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMetaGroupsList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMetaProjectStatusesList(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMetaProjectStatusesList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementMetaTicketStatusesList(options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementMetaTicketStatusesList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this notification model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementNotificationsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementNotificationsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [notificationType]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {number} [sender]
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementNotificationsList(
    currentPage?: number,
    notificationType?: string,
    ordering?: string,
    perPage?: number,
    search?: string,
    sender?: number,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementNotificationsList(
        currentPage,
        notificationType,
        ordering,
        perPage,
        search,
        sender,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this notification model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this notification model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementNotificationsMarkAsReadPartialUpdate(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementNotificationsMarkAsReadPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Project} [project]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsCreate(
    project?: Project,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsCreate(project, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this project model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [name]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {ApiV1ManagementProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
   * @param {string} [search] A search term.
   * @param {Array<ApiV1ManagementProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsList(
    client?: string,
    currentPage?: number,
    name?: string,
    ordering?: string,
    perPage?: number,
    projectStatus?: ApiV1ManagementProjectsListProjectStatusEnum,
    search?: string,
    sideload?: Array<ApiV1ManagementProjectsListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsList(
        client,
        currentPage,
        name,
        ordering,
        perPage,
        projectStatus,
        search,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this project model.
   * @param {PatchedProject} [patchedProject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsPartialUpdate(
    id: string,
    patchedProject?: PatchedProject,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsPartialUpdate(id, patchedProject, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this project model.
   * @param {Array<ApiV1ManagementProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementProjectsRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this project model.
   * @param {Project} [project]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementProjectsUpdate(
    id: string,
    project?: Project,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementProjectsUpdate(id, project, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   * @param {ApiV1ManagementSchemaRetrieveFormatEnum} [format]
   * @param {ApiV1ManagementSchemaRetrieveLangEnum} [lang]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementSchemaRetrieve(
    format?: ApiV1ManagementSchemaRetrieveFormatEnum,
    lang?: ApiV1ManagementSchemaRetrieveLangEnum,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementSchemaRetrieve(format, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Services} services
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesCreate(
    services: Services,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesCreate(services, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this services model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [name]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesList(
    currentPage?: number,
    name?: string,
    perPage?: number,
    search?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesList(currentPage, name, perPage, search, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this services model.
   * @param {PatchedServices} [patchedServices]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesPartialUpdate(
    id: string,
    patchedServices?: PatchedServices,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesPartialUpdate(id, patchedServices, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this services model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this services model.
   * @param {Services} services
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementServicesUpdate(
    id: string,
    services: Services,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementServicesUpdate(id, services, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [legalName]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [taxId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechClientsList(
    currentPage?: number,
    legalName?: string,
    perPage?: number,
    search?: string,
    taxId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechClientsList(
        currentPage,
        legalName,
        perPage,
        search,
        taxId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechLocationsList(
    currentPage?: number,
    perPage?: number,
    search?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechLocationsList(currentPage, perPage, search, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this location model.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechLocationsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechLocationsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [name]
   * @param {number} [perPage] Number of results to return per page.
   * @param {ApiV1ManagementTechProjectsListProjectStatusEnum} [projectStatus] * &#x60;ACTIVE&#x60; - Active * &#x60;COMPLETED&#x60; - Completed * &#x60;DELAYED&#x60; - Delayed
   * @param {string} [search] A search term.
   * @param {Array<ApiV1ManagementTechProjectsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechProjectsList(
    client?: string,
    currentPage?: number,
    name?: string,
    perPage?: number,
    projectStatus?: ApiV1ManagementTechProjectsListProjectStatusEnum,
    search?: string,
    sideload?: Array<ApiV1ManagementTechProjectsListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechProjectsList(
        client,
        currentPage,
        name,
        perPage,
        projectStatus,
        search,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this project model.
   * @param {Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechProjectsRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementTechProjectsRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechProjectsRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [location]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [serialNumber]
   * @param {Array<ApiV1ManagementTechTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechTurbinesList(
    client?: string,
    currentPage?: number,
    location?: string,
    perPage?: number,
    search?: string,
    serialNumber?: string,
    sideload?: Array<ApiV1ManagementTechTurbinesListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechTurbinesList(
        client,
        currentPage,
        location,
        perPage,
        search,
        serialNumber,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {PatchedTechnicianTurbine} [patchedTechnicianTurbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechTurbinesPartialUpdate(
    id: string,
    patchedTechnicianTurbine?: PatchedTechnicianTurbine,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechTurbinesPartialUpdate(id, patchedTechnicianTurbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechTurbinesRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementTechTurbinesRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechTurbinesRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {TechnicianTurbine} [technicianTurbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechTurbinesUpdate(
    id: string,
    technicianTurbine?: TechnicianTurbine,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechTurbinesUpdate(id, technicianTurbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {CheckIn} checkIn
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersCheckInCreate(
    id: string,
    checkIn: CheckIn,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersCheckInCreate(id, checkIn, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {CheckOutDatetime} checkOutDatetime
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersCheckOutCreate(
    id: string,
    checkOutDatetime: CheckOutDatetime,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersCheckOutCreate(id, checkOutDatetime, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest} [apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
    id: string,
    apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest?: ApiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersEndPartialUpdate(
        id,
        apiV1ManagementTechnicianWorkOrdersEndPartialUpdateRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [assigneesAssignee]
   * @param {string} [client]
   * @param {number} [coordinatorsCoordinator]
   * @param {number} [createdBy]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [itemsComponentSerialNumber]
   * @param {number} [managersManager]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [project]
   * @param {string} [search] A search term.
   * @param {string} [service]
   * @param {Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {ApiV1ManagementTechnicianWorkOrdersListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersList(
    assigneesAssignee?: number,
    client?: string,
    coordinatorsCoordinator?: number,
    createdBy?: number,
    currentPage?: number,
    itemsComponentSerialNumber?: string,
    managersManager?: number,
    ordering?: string,
    perPage?: number,
    project?: string,
    search?: string,
    service?: string,
    sideload?: Array<ApiV1ManagementTechnicianWorkOrdersListSideloadEnum>,
    status?: ApiV1ManagementTechnicianWorkOrdersListStatusEnum,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersList(
        assigneesAssignee,
        client,
        coordinatorsCoordinator,
        createdBy,
        currentPage,
        itemsComponentSerialNumber,
        managersManager,
        ordering,
        perPage,
        project,
        search,
        service,
        sideload,
        status,
        turbine,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [batch]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [material]
   * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum} [materialCategory] * &#x60;CHEMICALS&#x60; - Chemicals * &#x60;FABRIC&#x60; - Fabric
   * @param {string} [materialName]
   * @param {string} [materialSapCode]
   * @param {ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum} [measurementUnit] * &#x60;KG&#x60; - kg * &#x60;G&#x60; - g * &#x60;L&#x60; - L * &#x60;ML&#x60; - ml * &#x60;M2&#x60; - m² * &#x60;EACH&#x60; - each
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersMaterialsList(
    batch?: string,
    currentPage?: number,
    material?: string,
    materialCategory?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum,
    materialName?: string,
    materialSapCode?: string,
    measurementUnit?: ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum,
    ordering?: string,
    perPage?: number,
    search?: string,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersMaterialsList(
        batch,
        currentPage,
        material,
        materialCategory,
        materialName,
        materialSapCode,
        measurementUnit,
        ordering,
        perPage,
        search,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket materials usage.
   * @param {PatchedTicketMaterialsUsage} [patchedTicketMaterialsUsage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
    id: string,
    patchedTicketMaterialsUsage?: PatchedTicketMaterialsUsage,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersMaterialsPartialUpdate(
        id,
        patchedTicketMaterialsUsage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket materials usage.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersMaterialsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket materials usage.
   * @param {TicketMaterialsUsage} [ticketMaterialsUsage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
    id: string,
    ticketMaterialsUsage?: TicketMaterialsUsage,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersMaterialsUpdate(
        id,
        ticketMaterialsUsage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {PatchedTicket} [patchedTicket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersPartialUpdate(
    id: string,
    patchedTicket?: PatchedTicket,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersPartialUpdate(id, patchedTicket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {PatchedReportDelay} [patchedReportDelay]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
    id: string,
    patchedReportDelay?: PatchedReportDelay,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersReportDelayPartialUpdate(
        id,
        patchedReportDelay,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersStartPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {ManualTimeLog} manualTimeLog
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
    id: string,
    manualTimeLog: ManualTimeLog,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersTicketItemManualTimeLogCreate(
        id,
        manualTimeLog,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {Ticket} ticket
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTechnicianWorkOrdersUpdate(
    id: string,
    ticket: Ticket,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTechnicianWorkOrdersUpdate(id, ticket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {PatchedTicketIndexRequest} [patchedTicketIndexRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketAssignIndexPartialUpdate(
    id: string,
    patchedTicketIndexRequest?: PatchedTicketIndexRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketAssignIndexPartialUpdate(
        id,
        patchedTicketIndexRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TicketCommentReaction} ticketCommentReaction
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentReactionsCreate(
    ticketCommentReaction: TicketCommentReaction,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentReactionsCreate(ticketCommentReaction, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket comment reaction.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentReactionsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentReactionsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TicketComment} [ticketComment]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentsCreate(
    ticketComment?: TicketComment,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentsCreate(ticketComment, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket comment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentsDestroy(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentsDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {number} [replyTo]
   * @param {string} [ticket]
   * @param {string} [ticketItem]
   * @param {number} [user]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentsList(
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    replyTo?: number,
    ticket?: string,
    ticketItem?: string,
    user?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentsList(
        currentPage,
        ordering,
        perPage,
        replyTo,
        ticket,
        ticketItem,
        user,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket comment.
   * @param {PatchedTicketComment} [patchedTicketComment]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentsPartialUpdate(
    id: string,
    patchedTicketComment?: PatchedTicketComment,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentsPartialUpdate(id, patchedTicketComment, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket comment.
   * @param {TicketComment} [ticketComment]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCommentsUpdate(
    id: string,
    ticketComment?: TicketComment,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCommentsUpdate(id, ticketComment, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Ticket} ticket
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketCreate(ticket: Ticket, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketCreate(ticket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {number} [recipient]
   * @param {string} [search] A search term.
   * @param {number} [sender]
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketDelaysList(
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    recipient?: number,
    search?: string,
    sender?: number,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketDelaysList(
        currentPage,
        ordering,
        perPage,
        recipient,
        search,
        sender,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [assigneesAssignee]
   * @param {string} [client]
   * @param {number} [coordinatorsCoordinator]
   * @param {number} [createdBy]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [itemsComponentSerialNumber]
   * @param {number} [managersManager]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [project]
   * @param {boolean} [reportDone]
   * @param {string} [search] A search term.
   * @param {string} [service]
   * @param {Array<ApiV1ManagementTicketListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {ApiV1ManagementTicketListStatusEnum} [status] * &#x60;NEW&#x60; - New * &#x60;IN_PROGRESS&#x60; - In Progress * &#x60;STANDBY&#x60; - Stand By * &#x60;IN_REVIEW&#x60; - In Review * &#x60;DONE&#x60; - Done
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketList(
    assigneesAssignee?: number,
    client?: string,
    coordinatorsCoordinator?: number,
    createdBy?: number,
    currentPage?: number,
    itemsComponentSerialNumber?: string,
    managersManager?: number,
    ordering?: string,
    perPage?: number,
    project?: string,
    reportDone?: boolean,
    search?: string,
    service?: string,
    sideload?: Array<ApiV1ManagementTicketListSideloadEnum>,
    status?: ApiV1ManagementTicketListStatusEnum,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketList(
        assigneesAssignee,
        client,
        coordinatorsCoordinator,
        createdBy,
        currentPage,
        itemsComponentSerialNumber,
        managersManager,
        ordering,
        perPage,
        project,
        reportDone,
        search,
        service,
        sideload,
        status,
        turbine,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {PatchedTicket} [patchedTicket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketPartialUpdate(
    id: string,
    patchedTicket?: PatchedTicket,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketPartialUpdate(id, patchedTicket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {number} [recipient]
   * @param {string} [search] A search term.
   * @param {number} [sender]
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketRejectionsList(
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    recipient?: number,
    search?: string,
    sender?: number,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketRejectionsList(
        currentPage,
        ordering,
        perPage,
        recipient,
        search,
        sender,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {Array<ApiV1ManagementTicketRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementTicketRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketStandbyPeriodsList(
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketStandbyPeriodsList(
        currentPage,
        ordering,
        perPage,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket standby period.
   * @param {PatchedTicketStandbyPeriod} [patchedTicketStandbyPeriod]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketStandbyPeriodsPartialUpdate(
    id: string,
    patchedTicketStandbyPeriod?: PatchedTicketStandbyPeriod,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketStandbyPeriodsPartialUpdate(
        id,
        patchedTicketStandbyPeriod,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket standby period.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketStandbyPeriodsRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketStandbyPeriodsRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket standby period.
   * @param {TicketStandbyPeriodEdit} [ticketStandbyPeriodEdit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketStandbyPeriodsUpdate(
    id: string,
    ticketStandbyPeriodEdit?: TicketStandbyPeriodEdit,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketStandbyPeriodsUpdate(id, ticketStandbyPeriodEdit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketTicketApprovePartialUpdate(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketTicketApprovePartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {PatchedRejectTicket} [patchedRejectTicket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketTicketRejectPartialUpdate(
    id: string,
    patchedRejectTicket?: PatchedRejectTicket,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketTicketRejectPartialUpdate(id, patchedRejectTicket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this ticket.
   * @param {Ticket} ticket
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTicketUpdate(
    id: string,
    ticket: Ticket,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTicketUpdate(id, ticket, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this time tracking.
   * @param {number} [assignee]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [ticket]
   * @param {string} [ticketItem]
   * @param {PatchedTimeEntryEdit} [patchedTimeEntryEdit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTimeTrackingEditTimePartialUpdate(
    id: string,
    assignee?: number,
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    ticket?: string,
    ticketItem?: string,
    patchedTimeEntryEdit?: PatchedTimeEntryEdit,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTimeTrackingEditTimePartialUpdate(
        id,
        assignee,
        currentPage,
        ordering,
        perPage,
        ticket,
        ticketItem,
        patchedTimeEntryEdit,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [assignee]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [ticket]
   * @param {string} [ticketItem]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTimeTrackingList(
    assignee?: number,
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    ticket?: string,
    ticketItem?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTimeTrackingList(
        assignee,
        currentPage,
        ordering,
        perPage,
        ticket,
        ticketItem,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this time tracking.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTimeTrackingRetrieve(
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTimeTrackingRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} turbineId
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesComponentsList(
    turbineId: string,
    currentPage?: number,
    perPage?: number,
    sideload?: Array<ApiV1ManagementTurbinesComponentsListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesComponentsList(
        turbineId,
        currentPage,
        perPage,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Turbine} turbine
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesCreate(
    turbine: Turbine,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesCreate(turbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [location]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {string} [serialNumber]
   * @param {Array<ApiV1ManagementTurbinesListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesList(
    client?: string,
    currentPage?: number,
    location?: string,
    ordering?: string,
    perPage?: number,
    search?: string,
    serialNumber?: string,
    sideload?: Array<ApiV1ManagementTurbinesListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesList(
        client,
        currentPage,
        location,
        ordering,
        perPage,
        search,
        serialNumber,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {PatchedTurbine} [patchedTurbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesPartialUpdate(
    id: string,
    patchedTurbine?: PatchedTurbine,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesPartialUpdate(id, patchedTurbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesRetrieve(
    id: string,
    sideload?: Array<ApiV1ManagementTurbinesRetrieveSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesRetrieve(id, sideload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this turbine.
   * @param {Turbine} turbine
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesUpdate(
    id: string,
    turbine: Turbine,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesUpdate(id, turbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} turbineId
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>} [sideload] This option allows you to fetch related obejcts for all of the relations with a signle query. Multi-source sideloadable fields can be filtered by the sources by declaring the required sources in square brackets after the sideloading key. All available Mutli-source fields will have an example provided with all available sources. The comma separated sources can be ommited with the square brackets if all sources are to be sideloaded.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementTurbinesWorkOrdersList(
    turbineId: string,
    currentPage?: number,
    perPage?: number,
    sideload?: Array<ApiV1ManagementTurbinesWorkOrdersListSideloadEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementTurbinesWorkOrdersList(
        turbineId,
        currentPage,
        perPage,
        sideload,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {number} [targetUser]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserActionWorklogList(
    currentPage?: number,
    perPage?: number,
    search?: string,
    targetUser?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserActionWorklogList(
        currentPage,
        perPage,
        search,
        targetUser,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserCreateUpdate} userCreateUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementCreate(
    userCreateUpdate: UserCreateUpdate,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementCreate(userCreateUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementDeactivateUserPartialUpdate(
    id: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementDeactivateUserPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementDestroy(
    id: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [email]
   * @param {string} [groupsName]
   * @param {boolean} [isActive]
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {ApiV1ManagementUserManagementListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementList(
    currentPage?: number,
    email?: string,
    groupsName?: string,
    isActive?: boolean,
    ordering?: string,
    perPage?: number,
    search?: string,
    technicianLevel?: ApiV1ManagementUserManagementListTechnicianLevelEnum,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementList(
        currentPage,
        email,
        groupsName,
        isActive,
        ordering,
        perPage,
        search,
        technicianLevel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {PatchedUserCreateUpdate} [patchedUserCreateUpdate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementPartialUpdate(
    id: number,
    patchedUserCreateUpdate?: PatchedUserCreateUpdate,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementPartialUpdate(id, patchedUserCreateUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementReactivateUserPartialUpdate(
    id: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementReactivateUserPartialUpdate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementRetrieve(
    id: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id A unique integer value identifying this user.
   * @param {UserCreateUpdate} userCreateUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUserManagementUpdate(
    id: number,
    userCreateUpdate: UserCreateUpdate,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUserManagementUpdate(id, userCreateUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {ChangePassword} changePassword
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUsersChangePasswordCreate(
    id: string,
    changePassword: ChangePassword,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUsersChangePasswordCreate(id, changePassword, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [email]
   * @param {string} [groupsName]
   * @param {boolean} [isActive]
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [search] A search term.
   * @param {ApiV1ManagementUsersListTechnicianLevelEnum} [technicianLevel] * &#x60;L1&#x60; - L1 * &#x60;L2&#x60; - L2 * &#x60;L3&#x60; - L3
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUsersList(
    currentPage?: number,
    email?: string,
    groupsName?: string,
    isActive?: boolean,
    perPage?: number,
    search?: string,
    technicianLevel?: ApiV1ManagementUsersListTechnicianLevelEnum,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUsersList(
        currentPage,
        email,
        groupsName,
        isActive,
        perPage,
        search,
        technicianLevel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUsersRetrieve(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUsersRetrieve(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {PatchedUserProfile} [patchedUserProfile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementUsersUpdatePartialUpdate(
    id: string,
    patchedUserProfile?: PatchedUserProfile,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementUsersUpdatePartialUpdate(id, patchedUserProfile, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {WorkHistory} [workHistory]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkHistoryCreate(
    workHistory?: WorkHistory,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkHistoryCreate(workHistory, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this work history.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkHistoryDestroy(id: string, options?: RawAxiosRequestConfig) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkHistoryDestroy(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [component]
   * @param {number} [createdBy]
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {string} [ordering] Which field to use when ordering the results.
   * @param {number} [perPage] Number of results to return per page.
   * @param {string} [ticket]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkHistoryList(
    component?: string,
    createdBy?: number,
    currentPage?: number,
    ordering?: string,
    perPage?: number,
    ticket?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkHistoryList(
        component,
        createdBy,
        currentPage,
        ordering,
        perPage,
        ticket,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this work history.
   * @param {PatchedWorkHistory} [patchedWorkHistory]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkHistoryPartialUpdate(
    id: string,
    patchedWorkHistory?: PatchedWorkHistory,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkHistoryPartialUpdate(id, patchedWorkHistory, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id A UUID string identifying this work history.
   * @param {WorkHistory} [workHistory]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkHistoryUpdate(
    id: string,
    workHistory?: WorkHistory,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkHistoryUpdate(id, workHistory, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [client]
   * @param {string} [location]
   * @param {string} [turbine]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorkOrdersMetaRetrieve(
    client?: string,
    location?: string,
    turbine?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorkOrdersMetaRetrieve(client, location, turbine, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} ticketId
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorklogList(
    ticketId: string,
    currentPage?: number,
    perPage?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorklogList(ticketId, currentPage, perPage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} componentId
   * @param {string} ticketId
   * @param {number} [currentPage] A page number within the paginated result set.
   * @param {number} [perPage] Number of results to return per page.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ManagementWorklogList2(
    componentId: string,
    ticketId: string,
    currentPage?: number,
    perPage?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ApiApiFp(this.configuration)
      .apiV1ManagementWorklogList2(componentId, ticketId, currentPage, perPage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

export const ApiV1ManagementClientsTurbinesListSideloadEnum = {
  Client: "client",
  Location: "location",
} as const;
export type ApiV1ManagementClientsTurbinesListSideloadEnum =
  (typeof ApiV1ManagementClientsTurbinesListSideloadEnum)[keyof typeof ApiV1ManagementClientsTurbinesListSideloadEnum];
export const ApiV1ManagementComponentsListComponentTypeEnum = {
  Blade: "BLADE",
  Hub: "HUB",
  Nacelle: "NACELLE",
  Tower: "TOWER",
} as const;
export type ApiV1ManagementComponentsListComponentTypeEnum =
  (typeof ApiV1ManagementComponentsListComponentTypeEnum)[keyof typeof ApiV1ManagementComponentsListComponentTypeEnum];
export const ApiV1ManagementComponentsListSideloadEnum = {
  Turbine: "turbine",
} as const;
export type ApiV1ManagementComponentsListSideloadEnum =
  (typeof ApiV1ManagementComponentsListSideloadEnum)[keyof typeof ApiV1ManagementComponentsListSideloadEnum];
export const ApiV1ManagementComponentsRetrieveSideloadEnum = {
  Turbine: "turbine",
} as const;
export type ApiV1ManagementComponentsRetrieveSideloadEnum =
  (typeof ApiV1ManagementComponentsRetrieveSideloadEnum)[keyof typeof ApiV1ManagementComponentsRetrieveSideloadEnum];
export const ApiV1ManagementFilesListFileRelationsPurposeEnum = {
  Placeholder1: "PLACEHOLDER1",
  Placeholder2: "PLACEHOLDER2",
  Placeholder3: "PLACEHOLDER3",
} as const;
export type ApiV1ManagementFilesListFileRelationsPurposeEnum =
  (typeof ApiV1ManagementFilesListFileRelationsPurposeEnum)[keyof typeof ApiV1ManagementFilesListFileRelationsPurposeEnum];
export const ApiV1ManagementMaterialsListCategoryEnum = {
  Chemicals: "CHEMICALS",
  Fabric: "FABRIC",
} as const;
export type ApiV1ManagementMaterialsListCategoryEnum =
  (typeof ApiV1ManagementMaterialsListCategoryEnum)[keyof typeof ApiV1ManagementMaterialsListCategoryEnum];
export const ApiV1ManagementProjectsListProjectStatusEnum = {
  Active: "ACTIVE",
  Completed: "COMPLETED",
  Delayed: "DELAYED",
} as const;
export type ApiV1ManagementProjectsListProjectStatusEnum =
  (typeof ApiV1ManagementProjectsListProjectStatusEnum)[keyof typeof ApiV1ManagementProjectsListProjectStatusEnum];
export const ApiV1ManagementProjectsListSideloadEnum = {
  Client: "client",
} as const;
export type ApiV1ManagementProjectsListSideloadEnum =
  (typeof ApiV1ManagementProjectsListSideloadEnum)[keyof typeof ApiV1ManagementProjectsListSideloadEnum];
export const ApiV1ManagementProjectsRetrieveSideloadEnum = {
  Client: "client",
} as const;
export type ApiV1ManagementProjectsRetrieveSideloadEnum =
  (typeof ApiV1ManagementProjectsRetrieveSideloadEnum)[keyof typeof ApiV1ManagementProjectsRetrieveSideloadEnum];
export const ApiV1ManagementSchemaRetrieveFormatEnum = {
  Json: "json",
  Yaml: "yaml",
} as const;
export type ApiV1ManagementSchemaRetrieveFormatEnum =
  (typeof ApiV1ManagementSchemaRetrieveFormatEnum)[keyof typeof ApiV1ManagementSchemaRetrieveFormatEnum];
export const ApiV1ManagementSchemaRetrieveLangEnum = {
  Af: "af",
  Ar: "ar",
  ArDz: "ar-dz",
  Ast: "ast",
  Az: "az",
  Be: "be",
  Bg: "bg",
  Bn: "bn",
  Br: "br",
  Bs: "bs",
  Ca: "ca",
  Ckb: "ckb",
  Cs: "cs",
  Cy: "cy",
  Da: "da",
  De: "de",
  Dsb: "dsb",
  El: "el",
  En: "en",
  EnAu: "en-au",
  EnGb: "en-gb",
  Eo: "eo",
  Es: "es",
  EsAr: "es-ar",
  EsCo: "es-co",
  EsMx: "es-mx",
  EsNi: "es-ni",
  EsVe: "es-ve",
  Et: "et",
  Eu: "eu",
  Fa: "fa",
  Fi: "fi",
  Fr: "fr",
  Fy: "fy",
  Ga: "ga",
  Gd: "gd",
  Gl: "gl",
  He: "he",
  Hi: "hi",
  Hr: "hr",
  Hsb: "hsb",
  Ht: "ht",
  Hu: "hu",
  Hy: "hy",
  Ia: "ia",
  Id: "id",
  Ig: "ig",
  Io: "io",
  Is: "is",
  It: "it",
  Ja: "ja",
  Ka: "ka",
  Kab: "kab",
  Kk: "kk",
  Km: "km",
  Kn: "kn",
  Ko: "ko",
  Ky: "ky",
  Lb: "lb",
  Lt: "lt",
  Lv: "lv",
  Mk: "mk",
  Ml: "ml",
  Mn: "mn",
  Mr: "mr",
  Ms: "ms",
  My: "my",
  Nb: "nb",
  Ne: "ne",
  Nl: "nl",
  Nn: "nn",
  Os: "os",
  Pa: "pa",
  Pl: "pl",
  Pt: "pt",
  PtBr: "pt-br",
  Ro: "ro",
  Ru: "ru",
  Sk: "sk",
  Sl: "sl",
  Sq: "sq",
  Sr: "sr",
  SrLatn: "sr-latn",
  Sv: "sv",
  Sw: "sw",
  Ta: "ta",
  Te: "te",
  Tg: "tg",
  Th: "th",
  Tk: "tk",
  Tr: "tr",
  Tt: "tt",
  Udm: "udm",
  Ug: "ug",
  Uk: "uk",
  Ur: "ur",
  Uz: "uz",
  Vi: "vi",
  ZhHans: "zh-hans",
  ZhHant: "zh-hant",
} as const;
export type ApiV1ManagementSchemaRetrieveLangEnum =
  (typeof ApiV1ManagementSchemaRetrieveLangEnum)[keyof typeof ApiV1ManagementSchemaRetrieveLangEnum];
export const ApiV1ManagementTechProjectsListProjectStatusEnum = {
  Active: "ACTIVE",
  Completed: "COMPLETED",
  Delayed: "DELAYED",
} as const;
export type ApiV1ManagementTechProjectsListProjectStatusEnum =
  (typeof ApiV1ManagementTechProjectsListProjectStatusEnum)[keyof typeof ApiV1ManagementTechProjectsListProjectStatusEnum];
export const ApiV1ManagementTechProjectsListSideloadEnum = {
  Client: "client",
} as const;
export type ApiV1ManagementTechProjectsListSideloadEnum =
  (typeof ApiV1ManagementTechProjectsListSideloadEnum)[keyof typeof ApiV1ManagementTechProjectsListSideloadEnum];
export const ApiV1ManagementTechProjectsRetrieveSideloadEnum = {
  Client: "client",
} as const;
export type ApiV1ManagementTechProjectsRetrieveSideloadEnum =
  (typeof ApiV1ManagementTechProjectsRetrieveSideloadEnum)[keyof typeof ApiV1ManagementTechProjectsRetrieveSideloadEnum];
export const ApiV1ManagementTechTurbinesListSideloadEnum = {
  Client: "client",
  Location: "location",
} as const;
export type ApiV1ManagementTechTurbinesListSideloadEnum =
  (typeof ApiV1ManagementTechTurbinesListSideloadEnum)[keyof typeof ApiV1ManagementTechTurbinesListSideloadEnum];
export const ApiV1ManagementTechTurbinesRetrieveSideloadEnum = {
  Client: "client",
  Location: "location",
} as const;
export type ApiV1ManagementTechTurbinesRetrieveSideloadEnum =
  (typeof ApiV1ManagementTechTurbinesRetrieveSideloadEnum)[keyof typeof ApiV1ManagementTechTurbinesRetrieveSideloadEnum];
export const ApiV1ManagementTechnicianWorkOrdersListSideloadEnum = {
  Assignees: "assignees",
  Client: "client",
  Coordinator: "coordinator",
  Coordinators: "coordinators",
  CreatedBy: "created_by",
  Location: "location",
  Managers: "managers",
  Project: "project",
  Service: "service",
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTechnicianWorkOrdersListSideloadEnum =
  (typeof ApiV1ManagementTechnicianWorkOrdersListSideloadEnum)[keyof typeof ApiV1ManagementTechnicianWorkOrdersListSideloadEnum];
export const ApiV1ManagementTechnicianWorkOrdersListStatusEnum = {
  Done: "DONE",
  InProgress: "IN_PROGRESS",
  InReview: "IN_REVIEW",
  New: "NEW",
  Standby: "STANDBY",
} as const;
export type ApiV1ManagementTechnicianWorkOrdersListStatusEnum =
  (typeof ApiV1ManagementTechnicianWorkOrdersListStatusEnum)[keyof typeof ApiV1ManagementTechnicianWorkOrdersListStatusEnum];
export const ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum = {
  Chemicals: "CHEMICALS",
  Fabric: "FABRIC",
} as const;
export type ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum =
  (typeof ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum)[keyof typeof ApiV1ManagementTechnicianWorkOrdersMaterialsListMaterialCategoryEnum];
export const ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum = {
  Each: "EACH",
  G: "G",
  Kg: "KG",
  L: "L",
  M2: "M2",
  Ml: "ML",
} as const;
export type ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum =
  (typeof ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum)[keyof typeof ApiV1ManagementTechnicianWorkOrdersMaterialsListMeasurementUnitEnum];
export const ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum = {
  Assignees: "assignees",
  Client: "client",
  Coordinator: "coordinator",
  Coordinators: "coordinators",
  CreatedBy: "created_by",
  Location: "location",
  Managers: "managers",
  Project: "project",
  Service: "service",
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum =
  (typeof ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum)[keyof typeof ApiV1ManagementTechnicianWorkOrdersRetrieveSideloadEnum];
export const ApiV1ManagementTicketListSideloadEnum = {
  Assignees: "assignees",
  Client: "client",
  Coordinator: "coordinator",
  Coordinators: "coordinators",
  CreatedBy: "created_by",
  Location: "location",
  Managers: "managers",
  Project: "project",
  Service: "service",
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTicketListSideloadEnum =
  (typeof ApiV1ManagementTicketListSideloadEnum)[keyof typeof ApiV1ManagementTicketListSideloadEnum];
export const ApiV1ManagementTicketListStatusEnum = {
  Done: "DONE",
  InProgress: "IN_PROGRESS",
  InReview: "IN_REVIEW",
  New: "NEW",
  Standby: "STANDBY",
} as const;
export type ApiV1ManagementTicketListStatusEnum =
  (typeof ApiV1ManagementTicketListStatusEnum)[keyof typeof ApiV1ManagementTicketListStatusEnum];
export const ApiV1ManagementTicketRetrieveSideloadEnum = {
  Assignees: "assignees",
  Client: "client",
  Coordinator: "coordinator",
  Coordinators: "coordinators",
  CreatedBy: "created_by",
  Location: "location",
  Managers: "managers",
  Project: "project",
  Service: "service",
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTicketRetrieveSideloadEnum =
  (typeof ApiV1ManagementTicketRetrieveSideloadEnum)[keyof typeof ApiV1ManagementTicketRetrieveSideloadEnum];
export const ApiV1ManagementTurbinesComponentsListSideloadEnum = {
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTurbinesComponentsListSideloadEnum =
  (typeof ApiV1ManagementTurbinesComponentsListSideloadEnum)[keyof typeof ApiV1ManagementTurbinesComponentsListSideloadEnum];
export const ApiV1ManagementTurbinesListSideloadEnum = {
  Client: "client",
  Location: "location",
} as const;
export type ApiV1ManagementTurbinesListSideloadEnum =
  (typeof ApiV1ManagementTurbinesListSideloadEnum)[keyof typeof ApiV1ManagementTurbinesListSideloadEnum];
export const ApiV1ManagementTurbinesRetrieveSideloadEnum = {
  Client: "client",
  Location: "location",
} as const;
export type ApiV1ManagementTurbinesRetrieveSideloadEnum =
  (typeof ApiV1ManagementTurbinesRetrieveSideloadEnum)[keyof typeof ApiV1ManagementTurbinesRetrieveSideloadEnum];
export const ApiV1ManagementTurbinesWorkOrdersListSideloadEnum = {
  Assignees: "assignees",
  Client: "client",
  Coordinator: "coordinator",
  Coordinators: "coordinators",
  CreatedBy: "created_by",
  Location: "location",
  Managers: "managers",
  Project: "project",
  Service: "service",
  Turbine: "turbine",
} as const;
export type ApiV1ManagementTurbinesWorkOrdersListSideloadEnum =
  (typeof ApiV1ManagementTurbinesWorkOrdersListSideloadEnum)[keyof typeof ApiV1ManagementTurbinesWorkOrdersListSideloadEnum];
export const ApiV1ManagementUserManagementListTechnicianLevelEnum = {
  L1: "L1",
  L2: "L2",
  L3: "L3",
} as const;
export type ApiV1ManagementUserManagementListTechnicianLevelEnum =
  (typeof ApiV1ManagementUserManagementListTechnicianLevelEnum)[keyof typeof ApiV1ManagementUserManagementListTechnicianLevelEnum];
export const ApiV1ManagementUsersListTechnicianLevelEnum = {
  L1: "L1",
  L2: "L2",
  L3: "L3",
} as const;
export type ApiV1ManagementUsersListTechnicianLevelEnum =
  (typeof ApiV1ManagementUsersListTechnicianLevelEnum)[keyof typeof ApiV1ManagementUsersListTechnicianLevelEnum];
